import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const getAuthConfig = () => {
  // Correctif B7 : le cookie httpOnly porte la session.
  return {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' }
  };
};

const NAV = [
  { section: 'Principal' },
  { id: 'overview', label: "Vue d'ensemble", icon: 'ti-layout-dashboard' },
  { id: 'patients', label: 'Patients', icon: 'ti-users' },
  { id: 'admissions', label: 'Admissions', icon: 'ti-clipboard-list' },
  { id: 'beds', label: 'Gestion des lits', icon: 'ti-bed' },
  { id: 'appointments', label: 'Rendez-vous', icon: 'ti-calendar' },
  { section: 'Clinique' },
  { id: 'or', label: 'Bloc opératoire', icon: 'ti-scalpel' },
  { id: 'lab', label: 'Laboratoire', icon: 'ti-microscope' },
  { id: 'imaging', label: 'Imagerie', icon: 'ti-radio' },
  { id: 'pharmacy', label: 'Pharmacie', icon: 'ti-pill' },
  { section: 'Gestion' },
  { id: 'urgences', label: 'Urgences', icon: 'ti-ambulance' },
  { id: 'billing', label: 'Facturation', icon: 'ti-receipt' },
  { id: 'stats', label: 'Statistiques', icon: 'ti-chart-bar' },
  { id: 'staff', label: 'Personnel', icon: 'ti-users-group' },
  { id: 'settings', label: 'Paramètres', icon: 'ti-settings' },
];


const generateInvoicePDF = (clinicName, invoice) => {
  const { jsPDF } = window.jspdf;
  const doc = new jsPDF();
  const blue = [24, 95, 165];
  const gray = [100, 116, 139];
  const light = [248, 250, 252];

  doc.setFillColor(...blue);
  doc.rect(0, 0, 210, 18, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text(clinicName || 'Clinique', 14, 11);
  doc.setFontSize(12);
  doc.text('FACTURE', 196, 11, { align: 'right' });

  doc.setTextColor(0, 0, 0);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setFillColor(...light);
  doc.rect(14, 22, 182, 22, 'F');
  doc.setTextColor(...gray);
  doc.text('Patient :', 16, 29);
  doc.text('N° Facture :', 105, 29);
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'bold');
  doc.text(invoice.patient_id || '-', 40, 29);
  doc.text(invoice.invoice_id || '-', 135, 29);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...gray);
  doc.text('Assurance :', 16, 37);
  doc.text('Date :', 105, 37);
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'bold');
  doc.text(invoice.insurance_type ? invoice.insurance_type.toUpperCase() : 'Aucune', 40, 37);
  doc.text(new Date(invoice.created_at).toLocaleDateString('fr-FR'), 135, 37);

  let y = 52;
  doc.setFillColor(...blue);
  doc.rect(14, y, 182, 8, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('Description', 16, y + 5.5);
  doc.text('Qte', 130, y + 5.5, { align: 'center' });
  doc.text('Prix unit. (DA)', 158, y + 5.5, { align: 'center' });
  doc.text('Total (DA)', 192, y + 5.5, { align: 'right' });

  y += 8;
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'normal');
  let subtotal = 0;
  (invoice.items || []).forEach((item, i) => {
    const total = item.quantity * item.unit_price;
    subtotal += total;
    if (i % 2 === 0) { doc.setFillColor(...light); doc.rect(14, y, 182, 8, 'F'); }
    doc.text(item.description || '-', 16, y + 5.5);
    doc.text(String(item.quantity), 130, y + 5.5, { align: 'center' });
    doc.text(Number(item.unit_price).toLocaleString('fr-FR'), 158, y + 5.5, { align: 'center' });
    doc.text(Number(total).toLocaleString('fr-FR'), 192, y + 5.5, { align: 'right' });
    y += 8;
  });

  const discount = invoice.discount || 0;
  const total = subtotal * (1 - discount / 100);
  y += 4;
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...gray);
  doc.text('Sous-total :', 145, y);
  doc.setTextColor(0, 0, 0);
  doc.text(Number(subtotal).toLocaleString('fr-FR') + ' DA', 192, y, { align: 'right' });
  if (discount) {
    y += 7;
    doc.setTextColor(...gray);
    doc.text('Remise (' + discount + '%) :', 145, y);
    doc.setTextColor(163, 45, 45);
    doc.text('-' + Number(subtotal * discount / 100).toLocaleString('fr-FR') + ' DA', 192, y, { align: 'right' });
  }
  y += 7;
  doc.setFillColor(...[230, 241, 251]);
  doc.rect(130, y - 5, 66, 9, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...blue);
  doc.setFontSize(11);
  doc.text('TOTAL :', 145, y + 1);
  doc.text(Number(total).toLocaleString('fr-FR') + ' DA', 192, y + 1, { align: 'right' });

  y += 16;
  doc.setDrawColor(...[226, 232, 240]);
  doc.line(14, y, 196, y);
  y += 5;
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(...gray);
  doc.text('Document genere le ' + new Date().toLocaleString('fr-FR') + ' — ' + (clinicName || '') + ' — Tabbibak Pro', 105, y, { align: 'center' });

  doc.save('facture_' + (invoice.invoice_id || 'tabbibak') + '.pdf');
};

const generateLabPDF = (clinicName, patientName, bilanName, results) => {
  const { jsPDF } = window.jspdf;
  const doc = new jsPDF();
  const blue = [24, 95, 165];
  const gray = [100, 116, 139];
  const light = [248, 250, 252];
  const green = [59, 109, 17];
  const red = [163, 45, 45];

  doc.setFillColor(...blue);
  doc.rect(0, 0, 210, 18, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text(clinicName || 'Clinique', 14, 11);
  doc.text("BULLETIN D'ANALYSES", 196, 11, { align: 'right' });

  doc.setTextColor(0, 0, 0);
  doc.setFillColor(...light);
  doc.rect(14, 22, 182, 14, 'F');
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...gray);
  doc.text('Patient :', 16, 29);
  doc.text('Bilan :', 105, 29);
  doc.text('Date :', 16, 35);
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'bold');
  doc.text(patientName || '-', 40, 29);
  doc.text(bilanName || '-', 125, 29);
  doc.text(new Date().toLocaleDateString('fr-FR'), 35, 35);

  let y = 42;
  doc.setFillColor(...blue);
  doc.rect(14, y, 182, 8, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(9);
  doc.text('Analyse', 16, y + 5.5);
  doc.text('Resultat', 95, y + 5.5, { align: 'center' });
  doc.text('Unite', 125, y + 5.5, { align: 'center' });
  doc.text('Valeurs normales', 163, y + 5.5, { align: 'center' });
  doc.text('Statut', 194, y + 5.5, { align: 'right' });

  y += 8;
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'normal');
  results.forEach((r, i) => {
    if (i % 2 === 0) { doc.setFillColor(...light); doc.rect(14, y, 182, 8, 'F'); }
    doc.text(r.test_name || '-', 16, y + 5.5);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...(r.is_abnormal ? red : green));
    doc.text(r.result_value || '-', 95, y + 5.5, { align: 'center' });
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    doc.text(r.unit || '-', 125, y + 5.5, { align: 'center' });
    doc.text(r.reference_range || '-', 163, y + 5.5, { align: 'center' });
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...(r.is_abnormal ? red : green));
    doc.text(r.is_abnormal ? 'ANORMAL' : 'Normal', 194, y + 5.5, { align: 'right' });
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(0, 0, 0);
    y += 8;
  });

  y += 10;
  doc.setDrawColor(...[226, 232, 240]);
  doc.line(14, y, 196, y);
  y += 5;
  doc.setFontSize(8);
  doc.setTextColor(...gray);
  doc.text('Document genere le ' + new Date().toLocaleString('fr-FR') + ' — ' + (clinicName || '') + ' — Tabbibak Pro', 105, y, { align: 'center' });

  doc.save('bulletin_analyses_' + bilanName + '.pdf');
};

export default function ClinicProDashboard() {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [clinic, setClinic] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('overview');

  useEffect(() => {
    if (authLoading) return;
    if (!user || user.role !== 'clinic_admin') { navigate('/login'); return; }
    loadClinic();
  }, [user, authLoading]);

  const loadClinic = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/clinic/profile`, getAuthConfig());
      if (!res.data.is_pro) { navigate('/clinic/dashboard'); return; }
      setClinic(res.data);
    } catch (err) {
      navigate('/clinic/dashboard');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: 40, height: 40, border: '3px solid #E2E8F0', borderTopColor: '#185FA5', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', background: 'var(--color-background-tertiary, #F8FAFC)' }}>
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} clinic={clinic} navigate={navigate} />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <Topbar activeTab={activeTab} clinic={clinic} />
        <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>
          {activeTab === 'overview' && <OverviewTab clinic={clinic} />}
          {activeTab === 'admissions' && <AdmissionsTab />}
          {activeTab === 'beds' && <BedsTab />}
          {activeTab === 'appointments' && <AppointmentsTab />}
          {activeTab === 'patients' && <PatientsTab />}
          {activeTab === 'or' && <ORTab />}
          {activeTab === 'lab' && <LabTab />}
          {activeTab === 'imaging' && <ImagingTab />}
          {activeTab === 'pharmacy' && <PharmacyTab />}
          {activeTab === 'billing' && <BillingTab />}
          {activeTab === 'urgences' && <UrgencesTab />}
          {activeTab === 'stats' && <StatsTab />}
          {activeTab === 'staff' && <StaffTab />}
          {activeTab === 'settings' && <SettingsTab clinic={clinic} />}
        </div>
      </div>
    </div>
  );
}

function Sidebar({ activeTab, setActiveTab, clinic, navigate }) {
  return (
    <div style={{ width: 230, background: 'var(--color-background-primary, #fff)', borderRight: '0.5px solid var(--color-border-tertiary, #E2E8F0)', display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
      <div style={{ padding: '16px', borderBottom: '0.5px solid var(--color-border-tertiary, #E2E8F0)' }}>
        <div style={{ fontWeight: 500, fontSize: 14, color: 'var(--color-text-primary)', marginBottom: 4 }}>{clinic?.name}</div>
        <span style={{ fontSize: 11, background: '#E6F1FB', color: '#185FA5', padding: '2px 10px', borderRadius: 20 }}>Tabbibak Pro</span>
      </div>
      <div style={{ flex: 1, overflowY: 'auto', padding: '8px 0' }}>
        {NAV.map((item, i) => item.section ? (
          <div key={i} style={{ padding: '10px 16px 4px', fontSize: 10, color: 'var(--color-text-tertiary, #94A3B8)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
            {item.section}
          </div>
        ) : (
          <div
            key={item.id}
            onClick={() => setActiveTab(item.id)}
            style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '8px 12px', margin: '1px 8px',
              borderRadius: 8, cursor: 'pointer', fontSize: 13,
              background: activeTab === item.id ? '#EFF6FF' : 'transparent',
              color: activeTab === item.id ? '#185FA5' : 'var(--color-text-secondary, #64748B)',
              fontWeight: activeTab === item.id ? 500 : 400,
              transition: 'all 0.15s',
            }}
          >
            <i className={`ti ${item.icon}`} style={{ fontSize: 16 }} aria-hidden="true" />
            {item.label}
          </div>
        ))}
      </div>
      <div style={{ padding: 12, borderTop: '0.5px solid var(--color-border-tertiary, #E2E8F0)' }}>
        <button
          onClick={() => navigate('/clinic/dashboard')}
          style={{ width: '100%', display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px', borderRadius: 8, border: '0.5px solid var(--color-border-tertiary, #E2E8F0)', background: 'transparent', cursor: 'pointer', fontSize: 13, color: 'var(--color-text-secondary, #64748B)' }}
        >
          <i className="ti ti-arrow-left" style={{ fontSize: 16 }} aria-hidden="true" />
          Retour dashboard
        </button>
      </div>
    </div>
  );
}

function Topbar({ activeTab, clinic }) {
  const titles = {
    overview: "Vue d'ensemble", beds: 'Gestion des lits', appointments: 'Rendez-vous',
    patients: 'Patients', or: 'Bloc opératoire', lab: 'Laboratoire',
    imaging: 'Imagerie médicale', pharmacy: 'Pharmacie', billing: 'Facturation',
    stats: 'Statistiques', staff: 'Ressources humaines', settings: 'Paramètres',
  };
  const today = new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  return (
    <div style={{ padding: '12px 24px', background: 'var(--color-background-primary, #fff)', borderBottom: '0.5px solid var(--color-border-tertiary, #E2E8F0)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <div style={{ fontSize: 16, fontWeight: 500, color: 'var(--color-text-primary)' }}>{titles[activeTab]}</div>
      <div style={{ fontSize: 12, color: 'var(--color-text-secondary, #64748B)', textTransform: 'capitalize' }}>{today}</div>
    </div>
  );
}

function StatCard({ label, value, sub, color }) {
  return (
    <div style={{ background: 'var(--color-background-primary, #fff)', border: '0.5px solid var(--color-border-tertiary, #E2E8F0)', borderRadius: 10, padding: '14px 16px' }}>
      <div style={{ fontSize: 11, color: 'var(--color-text-secondary, #64748B)', marginBottom: 6 }}>{label}</div>
      <div style={{ fontSize: 24, fontWeight: 500, color: color || 'var(--color-text-primary)' }}>{value}</div>
      {sub && <div style={{ fontSize: 11, color: 'var(--color-text-tertiary, #94A3B8)', marginTop: 4 }}>{sub}</div>}
    </div>
  );
}

function Pill({ label, type }) {
  const styles = {
    success: { background: '#EAF3DE', color: '#3B6D11' },
    danger: { background: '#FCEBEB', color: '#A32D2D' },
    warning: { background: '#FAEEDA', color: '#854F0B' },
    info: { background: '#E6F1FB', color: '#185FA5' },
    neutral: { background: 'var(--color-background-secondary, #F8FAFC)', color: 'var(--color-text-secondary, #64748B)' },
  };
  const s = styles[type] || styles.neutral;
  return (
    <span style={{ display: 'inline-block', fontSize: 11, padding: '2px 10px', borderRadius: 20, ...s }}>{label}</span>
  );
}

function SectionHeader({ title, action, onClick }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
      <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--color-text-primary)' }}>{title}</div>
      {action && (
        <button onClick={onClick} style={{ display: 'flex', alignItems: 'center', gap: 6, padding: '6px 14px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
          <i className="ti ti-plus" style={{ fontSize: 14 }} aria-hidden="true" /> {action}
        </button>
      )}
    </div>
  );
}

function TableWrap({ headers, rows }) {
  return (
    <div style={{ border: '0.5px solid var(--color-border-tertiary, #E2E8F0)', borderRadius: 10, overflow: 'hidden' }}>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
        <thead style={{ background: 'var(--color-background-secondary, #F8FAFC)' }}>
          <tr>{headers.map((h, i) => <th key={i} style={{ padding: '10px 14px', textAlign: 'left', color: 'var(--color-text-secondary, #64748B)', fontWeight: 500, borderBottom: '0.5px solid var(--color-border-tertiary, #E2E8F0)', fontSize: 12 }}>{h}</th>)}</tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr><td colSpan={headers.length} style={{ padding: '32px 14px', textAlign: 'center', color: 'var(--color-text-tertiary, #94A3B8)' }}>Aucune donnée</td></tr>
          ) : rows.map((row, i) => (
            <tr key={i} style={{ borderBottom: i < rows.length - 1 ? '0.5px solid var(--color-border-tertiary, #E2E8F0)' : 'none' }}>
              {row.map((cell, j) => <td key={j} style={{ padding: '10px 14px', color: 'var(--color-text-primary)' }}>{cell}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

function InputField({ placeholder, value, onChange, type = 'text', style = {} }) {
  return (
    <input
      type={type} placeholder={placeholder} value={value} onChange={onChange}
      style={{ width: '100%', padding: '8px 12px', border: '0.5px solid var(--color-border-secondary, #CBD5E1)', borderRadius: 8, fontSize: 13, background: 'var(--color-background-primary, #fff)', color: 'var(--color-text-primary)', outline: 'none', ...style }}
    />
  );
}

function SelectField({ value, onChange, options, style = {} }) {
  return (
    <select
      value={value} onChange={onChange}
      style={{ width: '100%', padding: '8px 12px', border: '0.5px solid var(--color-border-secondary, #CBD5E1)', borderRadius: 8, fontSize: 13, background: 'var(--color-background-primary, #fff)', color: 'var(--color-text-primary)', outline: 'none', ...style }}
    >
      {options.map((o, i) => <option key={i} value={o.value}>{o.label}</option>)}
    </select>
  );
}

function FormCard({ title, children, onSave, onCancel }) {
  return (
    <div style={{ background: 'var(--color-background-primary, #fff)', border: '0.5px solid var(--color-border-tertiary, #E2E8F0)', borderRadius: 10, padding: '16px', marginBottom: 16 }}>
      <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 14, color: 'var(--color-text-primary)' }}>{title}</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 14 }}>{children}</div>
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={onSave} style={{ padding: '7px 18px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>Enregistrer</button>
        <button onClick={onCancel} style={{ padding: '7px 18px', background: 'transparent', border: '0.5px solid var(--color-border-secondary, #CBD5E1)', borderRadius: 8, fontSize: 13, cursor: 'pointer', color: 'var(--color-text-secondary)' }}>Annuler</button>
      </div>
    </div>
  );
}


function PatientDossier({ patient, onClose }) {
  const [activeTab, setActiveTab] = useState('vitals');
  const [vitals, setVitals] = useState([]);
  const [carePlan, setCarePlan] = useState([]);
  const [notes, setNotes] = useState([]);
  const [showVitalForm, setShowVitalForm] = useState(false);
  const [showNoteForm, setShowNoteForm] = useState(false);
  const [showCareForm, setShowCareForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [vitalForm, setVitalForm] = useState({
    blood_pressure_systolic: '', blood_pressure_diastolic: '',
    pulse: '', temperature: '', spo2: '', respiratory_rate: '',
    blood_glucose: '', weight: '', glasgow: '', pain_score: '',
    nurse_name: '', notes: '', measured_at: ''
  });
  const [noteForm, setNoteForm] = useState({ content: '', author: '', note_type: 'medical' });
  const [careForm, setCareForm] = useState({ time: '', description: '', date: '' });

  const pid = patient.clinic_patient_id || patient.patient_id;

  useEffect(() => { loadAll(); }, [pid]);

  const loadAll = async () => {
    try {
      const [v, c, n] = await Promise.all([
        axios.get(API_URL + '/api/pro/vitals/' + pid, getAuthConfig()),
        axios.get(API_URL + '/api/pro/care-plan/' + pid, getAuthConfig()),
        axios.get(API_URL + '/api/pro/notes/' + pid, getAuthConfig()),
      ]);
      setVitals(v.data.vitals || []);
      setCarePlan(c.data.plans || []);
      setNotes(n.data.notes || []);
    } catch(e) {}
  };

  const saveVitals = async () => {
    setSaving(true);
    try {
      await axios.post(API_URL + '/api/pro/vitals', { ...vitalForm, patient_id: pid, measured_at: vitalForm.measured_at || new Date().toISOString() }, getAuthConfig());
      setShowVitalForm(false);
      setVitalForm({ blood_pressure_systolic: '', blood_pressure_diastolic: '', pulse: '', temperature: '', spo2: '', respiratory_rate: '', blood_glucose: '', weight: '', glasgow: '', pain_score: '', nurse_name: '', notes: '', measured_at: '' });
      loadAll();
    } catch(e) { alert('Erreur'); }
    finally { setSaving(false); }
  };

  const saveNote = async () => {
    if (!noteForm.content) { alert('Le contenu est obligatoire'); return; }
    setSaving(true);
    try {
      await axios.post(API_URL + '/api/pro/notes', { ...noteForm, patient_id: pid }, getAuthConfig());
      setShowNoteForm(false);
      setNoteForm({ content: '', author: '', note_type: 'medical' });
      loadAll();
    } catch(e) { alert('Erreur'); }
    finally { setSaving(false); }
  };

  const saveCare = async () => {
    if (!careForm.description) { alert('La description est obligatoire'); return; }
    setSaving(true);
    try {
      await axios.post(API_URL + '/api/pro/care-plan', { ...careForm, patient_id: pid }, getAuthConfig());
      setShowCareForm(false);
      setCareForm({ time: '', description: '', date: '' });
      loadAll();
    } catch(e) { alert('Erreur'); }
    finally { setSaving(false); }
  };

  const updateCareStatus = async (planId, status) => {
    try {
      await axios.put(API_URL + '/api/pro/care-plan/' + planId, { status }, getAuthConfig());
      loadAll();
    } catch(e) {}
  };

  const lastVital = vitals[0] || null;

  const vitalStatus = (type, value) => {
    if (!value) return 'neutral';
    const v = parseFloat(value);
    if (type === 'spo2') return v >= 95 ? 'normal' : v >= 90 ? 'warning' : 'danger';
    if (type === 'pulse') return v >= 60 && v <= 90 ? 'normal' : v >= 50 && v <= 110 ? 'warning' : 'danger';
    if (type === 'temperature') return v >= 36 && v <= 37.5 ? 'normal' : v < 38.5 ? 'warning' : 'danger';
    if (type === 'systolic') return v >= 90 && v <= 140 ? 'normal' : v < 160 ? 'warning' : 'danger';
    if (type === 'glucose') return v >= 0.7 && v <= 1.1 ? 'normal' : v < 1.8 ? 'warning' : 'danger';
    if (type === 'resp') return v >= 12 && v <= 20 ? 'normal' : v < 25 ? 'warning' : 'danger';
    return 'normal';
  };

  const vitalColors = {
    normal: { bg: '#EAF3DE', border: '#C0DD97', text: '#3B6D11' },
    warning: { bg: '#FAEEDA', border: '#FAC775', text: '#854F0B' },
    danger: { bg: '#FCEBEB', border: '#F7C1C1', text: '#A32D2D' },
    neutral: { bg: 'var(--color-background-secondary)', border: 'var(--color-border-tertiary)', text: 'var(--color-text-secondary)' },
  };

  const VitalCard = ({ label, value, unit, type }) => {
    const s = vitalStatus(type, value);
    const c = vitalColors[s];
    return (
      <div style={{ background: c.bg, border: '0.5px solid ' + c.border, borderRadius: 10, padding: '12px 10px', textAlign: 'center' }}>
        <div style={{ fontSize: 22, fontWeight: 500, color: c.text }}>{value || '—'}</div>
        <div style={{ fontSize: 10, color: c.text, opacity: 0.8 }}>{unit}</div>
        <div style={{ fontSize: 11, color: c.text, marginTop: 4 }}>{label}</div>
      </div>
    );
  };

  const inputStyle = { width: '100%', padding: '8px 12px', border: '0.5px solid #CBD5E1', borderRadius: 8, fontSize: 13, color: 'var(--color-text-primary)', background: 'var(--color-background-primary)', outline: 'none' };
  const labelStyle = { fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4, display: 'block' };

  const TABS = [
    { id: 'vitals', label: 'Constantes vitales' },
    { id: 'care', label: 'Plan de soins' },
    { id: 'notes_med', label: 'Notes medicales' },
    { id: 'notes_inf', label: 'Notes infirmieres' },
  ];

  const careStatusColor = { pending: { bg: 'var(--color-background-secondary)', color: 'var(--color-text-secondary)' }, done: { bg: '#EAF3DE', color: '#3B6D11' }, in_progress: { bg: '#FAEEDA', color: '#854F0B' }, cancelled: { bg: '#FCEBEB', color: '#A32D2D' } };
  const careStatusLabel = { pending: 'A faire', done: 'Fait', in_progress: 'En cours', cancelled: 'Annule' };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: 20, overflow: 'auto' }}>
      <div style={{ background: 'var(--color-background-primary)', borderRadius: 12, width: '90%', maxWidth: 900, maxHeight: '90vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>

        <div style={{ padding: '14px 20px', background: '#E6F1FB', display: 'flex', alignItems: 'center', gap: 14, flexShrink: 0 }}>
          <div style={{ width: 48, height: 48, borderRadius: '50%', background: '#185FA5', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 16, fontWeight: 500, flexShrink: 0 }}>
            {(patient.first_name?.[0] || '') + (patient.last_name?.[0] || '')}
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 15, fontWeight: 500, color: '#0C447C' }}>{patient.first_name} {patient.last_name}</div>
            <div style={{ fontSize: 12, color: '#185FA5', marginTop: 2 }}>
              {patient.gender === 'female' ? 'F' : 'M'}
              {patient.date_of_birth ? ' — ' + (new Date().getFullYear() - new Date(patient.date_of_birth).getFullYear()) + ' ans' : ''}
              {patient.phone ? ' — ' + patient.phone : ''}
            </div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#185FA5', cursor: 'pointer', fontSize: 20, padding: '0 8px' }}>x</button>
        </div>

        <div style={{ display: 'flex', borderBottom: '0.5px solid var(--color-border-tertiary)', background: 'var(--color-background-secondary)', flexShrink: 0, overflowX: 'auto' }}>
          {TABS.map(t => (
            <button key={t.id} onClick={() => setActiveTab(t.id)}
              style={{ padding: '10px 16px', fontSize: 13, cursor: 'pointer', border: 'none', borderBottom: activeTab === t.id ? '2px solid #185FA5' : '2px solid transparent', color: activeTab === t.id ? '#185FA5' : 'var(--color-text-secondary)', fontWeight: activeTab === t.id ? 500 : 400, background: activeTab === t.id ? 'var(--color-background-primary)' : 'transparent', whiteSpace: 'nowrap' }}>
              {t.label}
            </button>
          ))}
        </div>

        <div style={{ flex: 1, overflowY: 'auto', padding: '16px 20px' }}>

          {activeTab === 'vitals' && (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                <div style={{ fontSize: 13, fontWeight: 500 }}>
                  {lastVital ? 'Dernieres constantes — ' + new Date(lastVital.measured_at).toLocaleString('fr-FR') : 'Aucune constante enregistree'}
                </div>
                <button onClick={() => setShowVitalForm(!showVitalForm)}
                  style={{ padding: '6px 14px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
                  + Saisir constantes
                </button>
              </div>

              {showVitalForm && (
                <div style={{ background: '#ffffff', border: '1.5px solid #B5D4F4', borderRadius: 10, padding: 20, marginBottom: 16, boxShadow: '0 2px 12px rgba(0,0,0,0.08)' }}>
                  <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 12 }}>Nouvelle saisie de constantes</div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '10px 14px', marginBottom: 12 }}>
                    <div>
                      <label style={labelStyle}>Tension systolique (mmHg)</label>
                      <input style={inputStyle} type="number" placeholder="ex: 120" value={vitalForm.blood_pressure_systolic} onChange={e => setVitalForm({...vitalForm, blood_pressure_systolic: e.target.value})} />
                    </div>
                    <div>
                      <label style={labelStyle}>Tension diastolique (mmHg)</label>
                      <input style={inputStyle} type="number" placeholder="ex: 80" value={vitalForm.blood_pressure_diastolic} onChange={e => setVitalForm({...vitalForm, blood_pressure_diastolic: e.target.value})} />
                    </div>
                    <div>
                      <label style={labelStyle}>Pouls (bpm)</label>
                      <input style={inputStyle} type="number" placeholder="ex: 72" value={vitalForm.pulse} onChange={e => setVitalForm({...vitalForm, pulse: e.target.value})} />
                    </div>
                    <div>
                      <label style={labelStyle}>Temperature (°C)</label>
                      <input style={inputStyle} type="number" step="0.1" placeholder="ex: 37.2" value={vitalForm.temperature} onChange={e => setVitalForm({...vitalForm, temperature: e.target.value})} />
                    </div>
                    <div>
                      <label style={labelStyle}>SpO2 (%)</label>
                      <input style={inputStyle} type="number" placeholder="ex: 98" value={vitalForm.spo2} onChange={e => setVitalForm({...vitalForm, spo2: e.target.value})} />
                    </div>
                    <div>
                      <label style={labelStyle}>Freq. respiratoire (c/min)</label>
                      <input style={inputStyle} type="number" placeholder="ex: 16" value={vitalForm.respiratory_rate} onChange={e => setVitalForm({...vitalForm, respiratory_rate: e.target.value})} />
                    </div>
                    <div>
                      <label style={labelStyle}>Glycemie (g/L)</label>
                      <input style={inputStyle} type="number" step="0.01" placeholder="ex: 0.95" value={vitalForm.blood_glucose} onChange={e => setVitalForm({...vitalForm, blood_glucose: e.target.value})} />
                    </div>
                    <div>
                      <label style={labelStyle}>Poids (kg)</label>
                      <input style={inputStyle} type="number" step="0.1" placeholder="ex: 75" value={vitalForm.weight} onChange={e => setVitalForm({...vitalForm, weight: e.target.value})} />
                    </div>
                    <div>
                      <label style={labelStyle}>Score Glasgow (/15)</label>
                      <input style={inputStyle} type="number" min="3" max="15" placeholder="ex: 15" value={vitalForm.glasgow} onChange={e => setVitalForm({...vitalForm, glasgow: e.target.value})} />
                    </div>
                    <div>
                      <label style={labelStyle}>Douleur EVA (/10)</label>
                      <input style={inputStyle} type="number" min="0" max="10" placeholder="ex: 3" value={vitalForm.pain_score} onChange={e => setVitalForm({...vitalForm, pain_score: e.target.value})} />
                    </div>
                    <div>
                      <label style={labelStyle}>Infirmier(e)</label>
                      <input style={inputStyle} placeholder="Nom" value={vitalForm.nurse_name} onChange={e => setVitalForm({...vitalForm, nurse_name: e.target.value})} />
                    </div>
                    <div>
                      <label style={labelStyle}>Date et heure</label>
                      <input style={inputStyle} type="datetime-local" value={vitalForm.measured_at} onChange={e => setVitalForm({...vitalForm, measured_at: e.target.value})} />
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button onClick={saveVitals} disabled={saving}
                      style={{ padding: '7px 16px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', opacity: saving ? 0.7 : 1 }}>
                      {saving ? 'Enregistrement...' : 'Enregistrer'}
                    </button>
                    <button onClick={() => setShowVitalForm(false)}
                      style={{ padding: '7px 16px', background: 'transparent', border: '0.5px solid var(--color-border-secondary)', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
                      Annuler
                    </button>
                  </div>
                </div>
              )}

              {lastVital && (
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10, marginBottom: 16 }}>
                  <VitalCard label="Tension arterielle" value={lastVital.blood_pressure_systolic && lastVital.blood_pressure_diastolic ? lastVital.blood_pressure_systolic + '/' + lastVital.blood_pressure_diastolic : lastVital.blood_pressure_systolic} unit="mmHg" type="systolic" />
                  <VitalCard label="Pouls" value={lastVital.pulse} unit="bpm" type="pulse" />
                  <VitalCard label="Temperature" value={lastVital.temperature} unit="°C" type="temperature" />
                  <VitalCard label="SpO2" value={lastVital.spo2} unit="%" type="spo2" />
                  <VitalCard label="Freq. respiratoire" value={lastVital.respiratory_rate} unit="c/min" type="resp" />
                  <VitalCard label="Glycemie" value={lastVital.blood_glucose} unit="g/L" type="glucose" />
                  <VitalCard label="Poids" value={lastVital.weight} unit="kg" type="neutral" />
                  <VitalCard label="Glasgow" value={lastVital.glasgow} unit="/15" type="neutral" />
                  {lastVital.pain_score !== undefined && lastVital.pain_score !== '' && (
                    <VitalCard label="Douleur EVA" value={lastVital.pain_score} unit="/10" type="neutral" />
                  )}
                </div>
              )}

              {vitals.length > 1 && (
                <div style={{ border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, overflow: 'hidden' }}>
                  <div style={{ padding: '10px 14px', background: 'var(--color-background-secondary)', fontSize: 12, fontWeight: 500, color: 'var(--color-text-secondary)', borderBottom: '0.5px solid var(--color-border-tertiary)' }}>
                    Historique des constantes
                  </div>
                  <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                    <thead>
                      <tr style={{ background: 'var(--color-background-secondary)' }}>
                        {['Date/Heure', 'TA', 'Pouls', 'Temp.', 'SpO2', 'FR', 'Glycemie', 'Glasgow', 'Infirmier'].map(h => (
                          <th key={h} style={{ padding: '8px 10px', textAlign: 'left', color: 'var(--color-text-secondary)', fontWeight: 500, fontSize: 11, borderBottom: '0.5px solid var(--color-border-tertiary)' }}>{h}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {vitals.map((v, i) => (
                        <tr key={i} style={{ borderBottom: '0.5px solid var(--color-border-tertiary)' }}>
                          <td style={{ padding: '8px 10px', fontSize: 11 }}>{new Date(v.measured_at).toLocaleString('fr-FR')}</td>
                          <td style={{ padding: '8px 10px' }}>{v.blood_pressure_systolic && v.blood_pressure_diastolic ? v.blood_pressure_systolic + '/' + v.blood_pressure_diastolic : v.blood_pressure_systolic || '—'}</td>
                          <td style={{ padding: '8px 10px' }}>{v.pulse || '—'}</td>
                          <td style={{ padding: '8px 10px' }}>{v.temperature || '—'}</td>
                          <td style={{ padding: '8px 10px' }}>{v.spo2 || '—'}</td>
                          <td style={{ padding: '8px 10px' }}>{v.respiratory_rate || '—'}</td>
                          <td style={{ padding: '8px 10px' }}>{v.blood_glucose || '—'}</td>
                          <td style={{ padding: '8px 10px' }}>{v.glasgow || '—'}</td>
                          <td style={{ padding: '8px 10px', color: 'var(--color-text-secondary)' }}>{v.nurse_name || '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {!lastVital && !showVitalForm && (
                <div style={{ textAlign: 'center', padding: 32, color: 'var(--color-text-tertiary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10 }}>
                  Aucune constante enregistree pour ce patient
                </div>
              )}
            </div>
          )}

          {activeTab === 'care' && (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                <div style={{ fontSize: 13, fontWeight: 500 }}>Plan de soins — Aujourd'hui</div>
                <button onClick={() => setShowCareForm(!showCareForm)}
                  style={{ padding: '6px 14px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
                  + Ajouter un soin
                </button>
              </div>

              {showCareForm && (
                <div style={{ background: '#F8FAFC', border: '0.5px solid #E2E8F0', borderRadius: 10, padding: 16, marginBottom: 14 }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr 1fr', gap: 10, marginBottom: 10 }}>
                    <div>
                      <label style={labelStyle}>Heure</label>
                      <input style={inputStyle} type="time" value={careForm.time} onChange={e => setCareForm({...careForm, time: e.target.value})} />
                    </div>
                    <div>
                      <label style={labelStyle}>Description du soin *</label>
                      <input style={inputStyle} placeholder="ex: Prise de sang NFS..." value={careForm.description} onChange={e => setCareForm({...careForm, description: e.target.value})} />
                    </div>
                    <div>
                      <label style={labelStyle}>Date</label>
                      <input style={inputStyle} type="date" value={careForm.date} onChange={e => setCareForm({...careForm, date: e.target.value})} />
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button onClick={saveCare} disabled={saving}
                      style={{ padding: '7px 16px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
                      Ajouter
                    </button>
                    <button onClick={() => setShowCareForm(false)}
                      style={{ padding: '7px 16px', background: 'transparent', border: '0.5px solid var(--color-border-secondary)', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
                      Annuler
                    </button>
                  </div>
                </div>
              )}

              {carePlan.length === 0 ? (
                <div style={{ textAlign: 'center', padding: 32, color: 'var(--color-text-tertiary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10 }}>
                  Aucun soin planifie pour aujourd'hui
                </div>
              ) : (
                <div style={{ border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, overflow: 'hidden' }}>
                  {carePlan.map((c, i) => (
                    <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px', borderBottom: i < carePlan.length-1 ? '0.5px solid var(--color-border-tertiary)' : 'none' }}>
                      <span style={{ fontSize: 12, background: '#E6F1FB', color: '#185FA5', padding: '3px 10px', borderRadius: 20, flexShrink: 0 }}>{c.time || '--:--'}</span>
                      <div style={{ flex: 1, fontSize: 13 }}>{c.description}</div>
                      <select value={c.status} onChange={e => updateCareStatus(c.plan_id, e.target.value)}
                        style={{ fontSize: 12, padding: '3px 8px', borderRadius: 6, border: '0.5px solid var(--color-border-tertiary)', background: careStatusColor[c.status]?.bg || 'var(--color-background-secondary)', color: careStatusColor[c.status]?.color || 'var(--color-text-secondary)', cursor: 'pointer' }}>
                        {Object.entries(careStatusLabel).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                      </select>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {(activeTab === 'notes_med' || activeTab === 'notes_inf') && (
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
                <div style={{ fontSize: 13, fontWeight: 500 }}>
                  {activeTab === 'notes_med' ? 'Notes medicales' : 'Notes infirmieres'}
                </div>
                <button onClick={() => setShowNoteForm(!showNoteForm)}
                  style={{ padding: '6px 14px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
                  + Ajouter une note
                </button>
              </div>

              {showNoteForm && (
                <div style={{ background: '#F8FAFC', border: '0.5px solid #E2E8F0', borderRadius: 10, padding: 16, marginBottom: 14 }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
                    <div>
                      <label style={labelStyle}>Auteur</label>
                      <input style={inputStyle} placeholder="Dr. Nom / Infirmier(e)" value={noteForm.author} onChange={e => setNoteForm({...noteForm, author: e.target.value})} />
                    </div>
                    <div>
                      <label style={labelStyle}>Type de note</label>
                      <select style={inputStyle} value={noteForm.note_type} onChange={e => setNoteForm({...noteForm, note_type: e.target.value})}>
                        <option value="medical">Note medicale</option>
                        <option value="nursing">Note infirmiere</option>
                        <option value="observation">Observation</option>
                        <option value="evolution">Evolution clinique</option>
                      </select>
                    </div>
                    <div style={{ gridColumn: 'span 2' }}>
                      <label style={labelStyle}>Contenu *</label>
                      <textarea style={{ ...inputStyle, resize: 'vertical', minHeight: 100 }}
                        placeholder="Saisir la note..."
                        value={noteForm.content} onChange={e => setNoteForm({...noteForm, content: e.target.value})} />
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button onClick={saveNote} disabled={saving}
                      style={{ padding: '7px 16px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
                      Enregistrer
                    </button>
                    <button onClick={() => setShowNoteForm(false)}
                      style={{ padding: '7px 16px', background: 'transparent', border: '0.5px solid var(--color-border-secondary)', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
                      Annuler
                    </button>
                  </div>
                </div>
              )}

              {notes.filter(n => activeTab === 'notes_med' ? n.note_type !== 'nursing' : n.note_type === 'nursing').length === 0 ? (
                <div style={{ textAlign: 'center', padding: 32, color: 'var(--color-text-tertiary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10 }}>
                  Aucune note enregistree
                </div>
              ) : (
                <div style={{ border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, overflow: 'hidden' }}>
                  {notes.filter(n => activeTab === 'notes_med' ? n.note_type !== 'nursing' : n.note_type === 'nursing').map((n, i, arr) => (
                    <div key={i} style={{ padding: '14px 16px', borderBottom: i < arr.length-1 ? '0.5px solid var(--color-border-tertiary)' : 'none' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <span style={{ fontSize: 13, fontWeight: 500 }}>{n.author || 'Anonyme'}</span>
                          <span style={{ fontSize: 11, background: '#E6F1FB', color: '#185FA5', padding: '1px 8px', borderRadius: 20 }}>{n.note_type}</span>
                        </div>
                        <span style={{ fontSize: 11, color: 'var(--color-text-tertiary)' }}>{new Date(n.created_at).toLocaleString('fr-FR')}</span>
                      </div>
                      <div style={{ fontSize: 13, color: 'var(--color-text-primary)', lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>{n.content}</div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

        </div>
      </div>
    </div>
  );
}

function OverviewTab({ clinic }) {
  const [beds, setBeds] = useState([]);
  const [admissions, setAdmissions] = useState([]);

  useEffect(() => {
    axios.get(`${API_URL}/api/pro/beds`, getAuthConfig()).then(r => setBeds(r.data.beds || [])).catch(() => {});
    axios.get(`${API_URL}/api/pro/admissions`, getAuthConfig()).then(r => setAdmissions(r.data.admissions || [])).catch(() => {});
  }, []);

  const available = beds.filter(b => b.status === 'available').length;
  const occupied = beds.filter(b => b.status === 'occupied').length;
  const maintenance = beds.filter(b => b.status === 'maintenance').length;

  const bedColor = { available: { bg: '#EAF3DE', color: '#3B6D11', border: '#C0DD97' }, occupied: { bg: '#FCEBEB', color: '#A32D2D', border: '#F7C1C1' }, maintenance: { bg: '#FAEEDA', color: '#854F0B', border: '#FAC775' } };

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 20 }}>
        <StatCard label="Lits occupés" value={`${occupied}/${beds.length}`} sub={beds.length ? `${Math.round(occupied/beds.length*100)}% d'occupation` : '—'} />
        <StatCard label="Lits disponibles" value={available} sub="Prêts pour admission" color="#3B6D11" />
        <StatCard label="En maintenance" value={maintenance} sub="Temporairement indisponibles" color="#854F0B" />
        <StatCard label="Total admissions" value={admissions.length} sub="Ce mois" />
      </div>

      {beds.length > 0 && (
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--color-text-primary)', marginBottom: 12 }}>Plan des lits</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(70px, 1fr))', gap: 6 }}>
            {beds.map(bed => {
              const s = bedColor[bed.status] || bedColor.available;
              return (
                <div key={bed.bed_id} style={{ background: s.bg, border: `0.5px solid ${s.border}`, borderRadius: 8, padding: '8px 6px', textAlign: 'center' }}>
                  <div style={{ fontSize: 13, fontWeight: 500, color: s.color }}>{bed.room_number}</div>
                  <div style={{ fontSize: 10, color: s.color, marginTop: 2 }}>{bed.status === 'available' ? 'Libre' : bed.status === 'occupied' ? 'Occupé' : 'Maint.'}</div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div style={{ fontSize: 14, fontWeight: 500, color: 'var(--color-text-primary)', marginBottom: 12 }}>Admissions récentes</div>
      <TableWrap
        headers={['Patient', 'Lit', 'Service', 'Médecin référent', 'Admission', 'Statut']}
        rows={admissions.slice(0, 10).map(a => [
          a.patient_name || a.patient_id,
          a.bed_number || '—',
          a.service || '—',
          a.doctor_name || '—',
          new Date(a.admitted_at).toLocaleDateString('fr-FR'),
          <Pill label={a.status === 'active' ? 'Admis' : a.status === 'discharged' ? 'Sorti' : 'En obs.'} type={a.status === 'active' ? 'success' : a.status === 'urgent' ? 'danger' : 'warning'} />
        ])}
      />
    </div>
  );
}

function BedsTab() {
  const SERVICES = ['Cardiologie', 'Neurologie', 'Chirurgie générale', 'Chirurgie orthopédique', 'Pédiatrie', 'Maternité', 'Gynécologie', 'Réanimation', 'Soins intensifs', 'Médecine interne', 'Pneumologie', 'Gastro-entérologie', 'Néphrologie', 'Urologie', 'Oncologie', 'Urgences', 'ORL', 'Ophtalmologie', 'Dermatologie', 'Psychiatrie'];

  const [beds, setBeds] = useState([]);
  const [admissions, setAdmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ room_number: '', room_type: 'standard', floor: '', service: '', status: 'available' });
  const [error, setError] = useState('');
  const [toDelete, setToDelete] = useState(null);
  const [editing, setEditing] = useState(null);
  const [search, setSearch] = useState('');
  const [filterService, setFilterService] = useState('');
  const [filterStatus, setFilterStatus] = useState('');

  useEffect(() => { loadBeds(); loadAdmissions(); }, []);

  const loadBeds = async () => {
    try { const r = await axios.get(`${API_URL}/api/pro/beds`, getAuthConfig()); setBeds(r.data.beds || []); }
    catch (e) { console.error(e); } finally { setLoading(false); }
  };
  const loadAdmissions = async () => {
    try { const r = await axios.get(`${API_URL}/api/pro/admissions`, getAuthConfig()); setAdmissions(r.data.admissions || []); }
    catch (e) {}
  };

  const resetForm = () => { setForm({ room_number: '', room_type: 'standard', floor: '', service: '', status: 'available' }); setEditing(null); setError(''); };

  const save = async () => {
    setError('');
    try {
      if (editing) {
        await axios.put(`${API_URL}/api/pro/beds/${editing}`, form, getAuthConfig());
      } else {
        await axios.post(`${API_URL}/api/pro/beds`, form, getAuthConfig());
      }
      setShowForm(false);
      resetForm();
      loadBeds();
    } catch (e) {
      setError(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Erreur lors de l'enregistrement du lit");
    }
  };

  const startEdit = (bed) => {
    setEditing(bed.bed_id);
    setForm({ room_number: bed.room_number || '', room_type: bed.room_type || 'standard', floor: bed.floor || '', service: bed.service || '', status: bed.status || 'available' });
    setError('');
    setShowForm(true);
  };

  const updateStatus = async (id, status) => {
    try { await axios.put(`${API_URL}/api/pro/beds/${id}`, { status }, getAuthConfig()); loadBeds(); }
    catch (e) { alert('Erreur'); }
  };

  const del = async () => {
    if (!toDelete) return;
    try {
      await axios.delete(`${API_URL}/api/pro/beds/${toDelete.bed_id}`, getAuthConfig());
      setToDelete(null);
      loadBeds();
    } catch (e) {
      alert('Erreur lors de la suppression');
    }
  };

  const bedColor = { available: '#EAF3DE', occupied: '#FCEBEB', maintenance: '#FAEEDA' };
  const bedTextColor = { available: '#3B6D11', occupied: '#A32D2D', maintenance: '#854F0B' };
  const bedLabel = { available: 'Disponible', occupied: 'Occupé', maintenance: 'Maintenance' };

  // Carte occupant : service::chambre -> nom patient (admissions actives)
  const occupantBy = {};
  admissions.filter(a => a.status === 'active' && a.bed_number).forEach(a => {
    occupantBy[`${a.service || ''}::${a.bed_number}`] = a.patient_name;
    occupantBy[`::${a.bed_number}`] = occupantBy[`::${a.bed_number}`] || a.patient_name;
  });
  const occupantOf = (b) => occupantBy[`${b.service || ''}::${b.room_number}`] || occupantBy[`::${b.room_number}`] || '';

  // Filtres
  const q = search.trim().toLowerCase();
  const filtered = beds.filter(b => {
    if (filterStatus && b.status !== filterStatus) return false;
    if (filterService && (b.service || '') !== filterService) return false;
    if (q && !((b.room_number || '').toLowerCase().includes(q) || (b.service || '').toLowerCase().includes(q))) return false;
    return true;
  });

  // Regroupement par service
  const groups = {};
  filtered.forEach(b => { const s = b.service || 'Sans service'; (groups[s] = groups[s] || []).push(b); });
  const groupNames = Object.keys(groups).sort((a, b) => a.localeCompare(b, 'fr'));

  // Liste des services presents (pour le filtre)
  const presentServices = Array.from(new Set(beds.map(b => b.service).filter(Boolean))).sort((a, b) => a.localeCompare(b, 'fr'));

  const serviceOptions = [
    { value: '', label: 'Service...' },
    ...(form.service && !SERVICES.includes(form.service) ? [{ value: form.service, label: form.service }] : []),
    ...SERVICES.map(s => ({ value: s, label: s })),
  ];

  const renderRows = (list) => list.map(b => [
    <span style={{ fontWeight: 500 }}>{b.room_number}</span>,
    b.room_type,
    b.floor || '—',
    <select value={b.status} onChange={e => updateStatus(b.bed_id, e.target.value)}
      style={{ fontSize: 12, padding: '3px 8px', borderRadius: 6, border: '0.5px solid var(--color-border-tertiary)', background: bedColor[b.status], color: bedTextColor[b.status], cursor: 'pointer' }}>
      <option value="available">Disponible</option>
      <option value="occupied">Occupé</option>
      <option value="maintenance">Maintenance</option>
    </select>,
    b.status === 'occupied'
      ? <span style={{ fontSize: 12, fontWeight: 500, color: 'var(--color-text-primary)' }}>{occupantOf(b) || <span style={{ color: 'var(--color-text-tertiary)', fontWeight: 400 }}>occupé</span>}</span>
      : <span style={{ color: 'var(--color-text-tertiary)' }}>—</span>,
    <span style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
      <button onClick={() => startEdit(b)} title="Modifier" style={{ fontSize: 12, color: '#185FA5', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
        <i className="ti ti-pencil" style={{ fontSize: 16 }} />
      </button>
      <button onClick={() => setToDelete(b)} title="Supprimer" style={{ fontSize: 12, color: '#A32D2D', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
        <i className="ti ti-trash" style={{ fontSize: 16 }} />
      </button>
    </span>
  ]);

  if (loading) return <div style={{ textAlign: 'center', padding: 40, color: 'var(--color-text-tertiary)' }}>Chargement...</div>;

  return (
    <div>
      <SectionHeader title="Gestion des lits" action="Ajouter un lit" onClick={() => { resetForm(); setShowForm(true); }} />

      {showForm && (
        <>
          {error && (
            <div style={{ background: '#FCEBEB', border: '0.5px solid #F7C1C1', color: '#A32D2D', borderRadius: 8, padding: '10px 14px', marginBottom: 12, fontSize: 13 }}>
              {error}
            </div>
          )}
          <FormCard title={editing ? "Modifier le lit" : "Nouveau lit"} onSave={save} onCancel={() => { setShowForm(false); resetForm(); }}>
            <InputField placeholder="Numéro de chambre *" value={form.room_number} onChange={e => setForm({...form, room_number: e.target.value})} />
            <SelectField value={form.room_type} onChange={e => setForm({...form, room_type: e.target.value})} options={[
              {value:'standard',label:'Standard'},{value:'vip',label:'VIP'},{value:'reanimation',label:'Réanimation'},
              {value:'maternite',label:'Maternité'},{value:'pediatrie',label:'Pédiatrie'},{value:'chirurgie',label:'Chirurgie'},
            ]} />
            <InputField placeholder="Étage" value={form.floor} onChange={e => setForm({...form, floor: e.target.value})} />
            <SelectField value={form.service} onChange={e => setForm({...form, service: e.target.value})} options={serviceOptions} />
          </FormCard>
        </>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10, marginBottom: 16 }}>
        {['available','occupied','maintenance'].map(s => (
          <div key={s} style={{ background: bedColor[s], border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, padding: '14px 16px', textAlign: 'center' }}>
            <div style={{ fontSize: 28, fontWeight: 500, color: bedTextColor[s] }}>{beds.filter(b => b.status === s).length}</div>
            <div style={{ fontSize: 12, color: bedTextColor[s], marginTop: 4 }}>{bedLabel[s]}</div>
          </div>
        ))}
        <div style={{ background: 'var(--color-background-primary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, padding: '14px 16px', textAlign: 'center' }}>
          <div style={{ fontSize: 28, fontWeight: 500, color: 'var(--color-text-primary)' }}>{beds.length}</div>
          <div style={{ fontSize: 12, color: 'var(--color-text-secondary)', marginTop: 4 }}>Total</div>
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 18, flexWrap: 'wrap', alignItems: 'center' }}>
        <div style={{ flex: '1 1 200px', minWidth: 180 }}>
          <InputField placeholder="Rechercher (chambre, service)..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <select value={filterService} onChange={e => setFilterService(e.target.value)}
          style={{ fontSize: 13, padding: '8px 12px', borderRadius: 8, border: '0.5px solid #CBD5E1', background: '#fff', color: 'var(--color-text-primary)', cursor: 'pointer' }}>
          <option value="">Tous les services</option>
          {presentServices.map(s => <option key={s} value={s}>{s}</option>)}
        </select>
        <select value={filterStatus} onChange={e => setFilterStatus(e.target.value)}
          style={{ fontSize: 13, padding: '8px 12px', borderRadius: 8, border: '0.5px solid #CBD5E1', background: '#fff', color: 'var(--color-text-primary)', cursor: 'pointer' }}>
          <option value="">Tous les statuts</option>
          <option value="available">Disponible</option>
          <option value="occupied">Occupé</option>
          <option value="maintenance">Maintenance</option>
        </select>
        {(search || filterService || filterStatus) && (
          <button onClick={() => { setSearch(''); setFilterService(''); setFilterStatus(''); }}
            style={{ fontSize: 12, padding: '8px 12px', borderRadius: 8, border: '0.5px solid var(--color-border-tertiary)', background: '#fff', color: 'var(--color-text-secondary)', cursor: 'pointer' }}>Réinitialiser</button>
        )}
      </div>

      {filtered.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, color: 'var(--color-text-tertiary)', border: '0.5px dashed var(--color-border-tertiary)', borderRadius: 10 }}>
          {beds.length === 0 ? 'Aucun lit. Cliquez sur « Ajouter un lit ».' : 'Aucun lit ne correspond aux filtres.'}
        </div>
      ) : (
        groupNames.map(serviceName => {
          const list = groups[serviceName];
          const occ = list.filter(b => b.status === 'occupied').length;
          return (
            <div key={serviceName} style={{ marginBottom: 22 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                <span style={{ fontSize: 14, fontWeight: 600, color: '#185FA5' }}>{serviceName}</span>
                <span style={{ fontSize: 12, color: 'var(--color-text-secondary)', background: '#E6F1FB', padding: '2px 10px', borderRadius: 20 }}>{list.length} lit{list.length > 1 ? 's' : ''} · {occ} occupé{occ > 1 ? 's' : ''}</span>
              </div>
              <TableWrap
                headers={['Chambre', 'Type', 'Étage', 'Statut', 'Occupant', 'Actions']}
                rows={renderRows(list)}
              />
            </div>
          );
        })
      )}

      {toDelete && (
        <div onClick={() => setToDelete(null)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#ffffff', borderRadius: 12, width: '90%', maxWidth: 380, padding: 24, boxShadow: '0 8px 30px rgba(0,0,0,0.18)' }}>
            <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--color-text-primary)', marginBottom: 8 }}>Supprimer ce lit ?</div>
            <div style={{ fontSize: 13, color: 'var(--color-text-secondary)', marginBottom: 20, lineHeight: 1.5 }}>
              Chambre <b>{toDelete.room_number}</b>{toDelete.service ? <> — {toDelete.service}</> : ''}. Cette action est irréversible.
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setToDelete(null)} style={{ fontSize: 13, padding: '8px 16px', borderRadius: 8, border: '0.5px solid var(--color-border-tertiary)', background: '#fff', color: 'var(--color-text-secondary)', cursor: 'pointer' }}>Annuler</button>
              <button onClick={del} style={{ fontSize: 13, padding: '8px 16px', borderRadius: 8, border: 'none', background: '#A32D2D', color: '#fff', cursor: 'pointer' }}>Supprimer</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function AppointmentsTab() {
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [doctors, setDoctors] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [patients, setPatients] = useState([]);
  const [patientSearch, setPatientSearch] = useState('');
  const [toCancel, setToCancel] = useState(null);
  const [form, setForm] = useState({ doctor_id: '', clinic_patient_id: '', patient_name: '', date: '', time: '', reason: '' });

  const load = () => {
    setLoading(true);
    axios.get(`${API_URL}/api/clinic/appointments`, getAuthConfig())
      .then(r => setAppointments(r.data.appointments || r.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  };
  const loadDoctors = () => {
    axios.get(`${API_URL}/api/clinic/doctors`, getAuthConfig())
      .then(r => setDoctors(Array.isArray(r.data) ? r.data : (r.data.doctors || [])))
      .catch(() => {});
  };
  useEffect(() => { load(); loadDoctors(); }, []);

  const resetForm = () => { setForm({ doctor_id: '', clinic_patient_id: '', patient_name: '', date: '', time: '', reason: '' }); setPatients([]); setPatientSearch(''); setError(''); };

  const searchPatients = async () => {
    if (!patientSearch.trim()) return;
    try { const r = await axios.get(API_URL + '/api/clinic/patients?search=' + encodeURIComponent(patientSearch), getAuthConfig()); setPatients(r.data.patients || []); }
    catch(e) { setPatients([]); }
  };
  const selectPatient = (p) => {
    setPatients([]);
    setPatientSearch(p.first_name + ' ' + p.last_name);
    setForm({...form, clinic_patient_id: p.patient_id, patient_name: p.first_name + ' ' + p.last_name});
  };

  const save = async () => {
    if (!form.doctor_id || !form.clinic_patient_id || !form.date || !form.time) {
      setError('Medecin, patient, date et heure sont obligatoires'); return;
    }
    setSaving(true); setError('');
    try {
      await axios.post(API_URL + '/api/clinic/appointments', form, getAuthConfig());
      setShowForm(false); resetForm(); load();
    } catch(e) { setError(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Erreur lors de la creation du RDV"); }
    finally { setSaving(false); }
  };

  const setStatus = async (id, status) => {
    setError('');
    try {
      await axios.put(API_URL + '/api/clinic/appointments/' + id + '/status', { status }, getAuthConfig());
      setToCancel(null); load();
    } catch(e) { setError('Erreur lors de la mise a jour du statut'); setToCancel(null); }
  };

  if (loading) return <div style={{ textAlign: 'center', padding: 40, color: 'var(--color-text-tertiary)' }}>Chargement...</div>;

  return (
    <div>
      <SectionHeader title="Rendez-vous" action="Nouveau rendez-vous" onClick={() => { resetForm(); setShowForm(true); }} />

      {error && (
        <div style={{ background: '#FCEBEB', border: '0.5px solid #F7C1C1', color: '#A32D2D', borderRadius: 8, padding: '10px 14px', marginBottom: 12, fontSize: 13 }}>{error}</div>
      )}

      {showForm && (
        <div style={{ background: '#ffffff', border: '1.5px solid #B5D4F4', borderRadius: 10, padding: 20, marginBottom: 16 }}>
          <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 14 }}>Nouveau rendez-vous</div>
          <div style={{ marginBottom: 10 }}>
            <div style={{ display: 'flex', gap: 8 }}>
              <InputField placeholder="Rechercher le patient..." value={patientSearch} onChange={e => setPatientSearch(e.target.value)} style={{ flex: 1 }} />
              <button onClick={searchPatients} style={{ padding: '8px 16px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>Rechercher</button>
            </div>
            {patients.length > 0 && (
              <div style={{ border: '0.5px solid #B5D4F4', borderRadius: 8, marginTop: 6, maxHeight: 160, overflow: 'auto' }}>
                {patients.map(p => (
                  <div key={p.patient_id} onClick={() => selectPatient(p)} style={{ padding: '8px 12px', cursor: 'pointer', fontSize: 13, borderBottom: '0.5px solid #EEF4FB' }}>
                    {p.first_name} {p.last_name} <span style={{ color: 'var(--color-text-tertiary)' }}>· {p.phone || '—'}</span>
                  </div>
                ))}
              </div>
            )}
            {form.patient_name && <div style={{ fontSize: 12, color: '#185FA5', marginTop: 6 }}>Patient selectionne : <b>{form.patient_name}</b></div>}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 14 }}>
            <SelectField value={form.doctor_id} onChange={e => setForm({...form, doctor_id: e.target.value})} options={[
              {value:'',label:'Medecin...'},
              ...doctors.map(d => ({ value: d.doctor_id, label: d.name || ((d.first_name || '') + ' ' + (d.last_name || '')) }))
            ]} />
            <InputField placeholder="Motif" value={form.reason} onChange={e => setForm({...form, reason: e.target.value})} />
            <InputField placeholder="Date" type="date" value={form.date} onChange={e => setForm({...form, date: e.target.value})} />
            <InputField placeholder="Heure" type="time" value={form.time} onChange={e => setForm({...form, time: e.target.value})} />
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={save} disabled={saving} style={{ padding: '7px 18px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>{saving ? 'Enregistrement...' : 'Enregistrer'}</button>
            <button onClick={() => { setShowForm(false); resetForm(); }} style={{ padding: '7px 18px', background: 'transparent', border: '0.5px solid var(--color-border-secondary)', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>Annuler</button>
          </div>
        </div>
      )}

      <TableWrap
        headers={['Patient', 'Médecin', 'Date', 'Heure', 'Motif', 'Statut', 'Actions']}
        rows={appointments.map(a => [
          a.patient_name || a.patient_id || '—',
          a.doctor_name || '—',
          a.date,
          a.time,
          a.reason || '—',
          <Pill label={a.status === 'confirmed' ? 'Confirmé' : a.status === 'pending' ? 'En attente' : a.status === 'completed' ? 'Terminé' : 'Annulé'}
            type={a.status === 'confirmed' ? 'success' : a.status === 'pending' ? 'warning' : a.status === 'completed' ? 'info' : 'danger'} />,
          <span style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {a.status === 'pending' && (
              <button onClick={() => setStatus(a.appointment_id, 'confirmed')} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '0.5px solid #C0DD97', cursor: 'pointer', background: '#EAF3DE', color: '#3B6D11' }}>Confirmer</button>
            )}
            {a.status === 'confirmed' && (
              <button onClick={() => setStatus(a.appointment_id, 'completed')} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '0.5px solid #B5D4F4', cursor: 'pointer', background: '#E6F1FB', color: '#185FA5' }}>Terminer</button>
            )}
            {(a.status === 'pending' || a.status === 'confirmed') && (
              <button onClick={() => setToCancel(a)} style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '0.5px solid #F7C1C1', cursor: 'pointer', background: '#FCEBEB', color: '#A32D2D' }}>Annuler</button>
            )}
            {(a.status === 'cancelled' || a.status === 'completed') && <span style={{ fontSize: 12, color: 'var(--color-text-tertiary)' }}>—</span>}
          </span>
        ])}
      />

      {toCancel && (
        <div onClick={() => setToCancel(null)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#ffffff', borderRadius: 12, width: '90%', maxWidth: 400, padding: 24, boxShadow: '0 8px 30px rgba(0,0,0,0.18)' }}>
            <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--color-text-primary)', marginBottom: 8 }}>Annuler ce rendez-vous ?</div>
            <div style={{ fontSize: 13, color: 'var(--color-text-secondary)', marginBottom: 20, lineHeight: 1.5 }}>
              RDV de <b>{toCancel.patient_name || toCancel.patient_id}</b> le {toCancel.date} a {toCancel.time}. Le patient sera notifie.
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setToCancel(null)} style={{ fontSize: 13, padding: '8px 16px', borderRadius: 8, border: '0.5px solid var(--color-border-tertiary)', background: '#fff', color: 'var(--color-text-secondary)', cursor: 'pointer' }}>Retour</button>
              <button onClick={() => setStatus(toCancel.appointment_id, 'cancelled')} style={{ fontSize: 13, padding: '8px 16px', borderRadius: 8, border: 'none', background: '#A32D2D', color: '#fff', cursor: 'pointer' }}>Annuler le RDV</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function PatientsTab() {
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ first_name: '', last_name: '', phone: '', date_of_birth: '', gender: '', blood_type: '' });
  const [editing, setEditing] = useState(null);
  const [patientToDelete, setPatientToDelete] = useState(null);

  const loadPatients = () => {
    setLoading(true);
    axios.get(API_URL + '/api/clinic/patients', getAuthConfig())
      .then(r => setPatients(r.data.patients || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { loadPatients(); }, []);

  const resetForm = () => { setForm({ first_name: '', last_name: '', phone: '', date_of_birth: '', gender: '', blood_type: '' }); setEditing(null); setError(''); };

  const save = async () => {
    if (!form.first_name.trim() || !form.last_name.trim() || !form.phone.trim()) {
      setError('Nom, prenom et telephone sont obligatoires'); return;
    }
    setSaving(true); setError('');
    try {
      if (editing) {
        await axios.put(API_URL + '/api/clinic/patients/' + editing, form, getAuthConfig());
      } else {
        await axios.post(API_URL + '/api/clinic/patients', form, getAuthConfig());
      }
      setShowForm(false); resetForm(); loadPatients();
    } catch (e) {
      setError(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Erreur lors de l'enregistrement du patient");
    } finally { setSaving(false); }
  };

  const startEdit = (p) => {
    setEditing(p.patient_id);
    setForm({ first_name: p.first_name || '', last_name: p.last_name || '', phone: p.phone || '', date_of_birth: p.date_of_birth || '', gender: p.gender || '', blood_type: p.blood_type || '' });
    setError(''); setShowForm(true);
  };

  const doDelete = async () => {
    if (!patientToDelete) return;
    try {
      await axios.delete(API_URL + '/api/clinic/patients/' + patientToDelete.patient_id, getAuthConfig());
      setPatientToDelete(null); loadPatients();
    } catch (e) { setError('Erreur lors de la suppression'); setPatientToDelete(null); }
  };

  const filtered = patients.filter(p =>
    (p.first_name + ' ' + p.last_name + ' ' + (p.phone || '')).toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div style={{ textAlign: 'center', padding: 40, color: 'var(--color-text-tertiary)' }}>Chargement...</div>;

  return (
    <div>
      {selectedPatient && <PatientDossier patient={selectedPatient} onClose={() => setSelectedPatient(null)} />}
      <SectionHeader title="Patients" action="Nouveau patient" onClick={() => { resetForm(); setShowForm(true); }} />

      {showForm && (
        <>
          {error && (
            <div style={{ background: '#FCEBEB', border: '0.5px solid #F7C1C1', color: '#A32D2D', borderRadius: 8, padding: '10px 14px', marginBottom: 12, fontSize: 13 }}>{error}</div>
          )}
          <FormCard title={editing ? "Modifier le patient" : "Nouveau patient"} onSave={save} onCancel={() => { setShowForm(false); resetForm(); }}>
            <InputField placeholder="Prenom *" value={form.first_name} onChange={e => setForm({...form, first_name: e.target.value})} />
            <InputField placeholder="Nom *" value={form.last_name} onChange={e => setForm({...form, last_name: e.target.value})} />
            <InputField placeholder="Telephone *" type="tel" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
            <InputField placeholder="Date de naissance" type="date" value={form.date_of_birth} onChange={e => setForm({...form, date_of_birth: e.target.value})} />
            <SelectField value={form.gender} onChange={e => setForm({...form, gender: e.target.value})} options={[
              {value:'',label:'Sexe...'},{value:'male',label:'Homme'},{value:'female',label:'Femme'},
            ]} />
            <SelectField value={form.blood_type} onChange={e => setForm({...form, blood_type: e.target.value})} options={[
              {value:'',label:'Groupe sanguin...'},{value:'A+',label:'A+'},{value:'A-',label:'A-'},{value:'B+',label:'B+'},{value:'B-',label:'B-'},{value:'AB+',label:'AB+'},{value:'AB-',label:'AB-'},{value:'O+',label:'O+'},{value:'O-',label:'O-'},
            ]} />
          </FormCard>
        </>
      )}

      <div style={{ marginBottom: 14 }}>
        <InputField placeholder="Rechercher un patient..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>
      <TableWrap
        headers={['Nom', 'Telephone', 'Age', 'Groupe sanguin', 'Derniere visite', 'Dossier']}
        rows={filtered.map(p => [
          <span style={{ fontWeight: 500 }}>{p.first_name} {p.last_name}</span>,
          p.phone || '-',
          p.date_of_birth ? (new Date().getFullYear() - new Date(p.date_of_birth).getFullYear()) + ' ans' : '-',
          p.blood_type || '-',
          p.last_visit ? new Date(p.last_visit).toLocaleDateString('fr-FR') : '-',
          <span style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            <button onClick={() => setSelectedPatient(p)}
              style={{ padding: '4px 12px', background: '#E6F1FB', color: '#185FA5', border: '0.5px solid #B5D4F4', borderRadius: 6, fontSize: 12, cursor: 'pointer', fontWeight: 500 }}>
              Voir dossier
            </button>
            <button onClick={() => startEdit(p)} title="Modifier" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#185FA5', padding: 0 }}>
              <i className="ti ti-pencil" style={{ fontSize: 16 }} />
            </button>
            <button onClick={() => setPatientToDelete(p)} title="Supprimer" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#A32D2D', padding: 0 }}>
              <i className="ti ti-trash" style={{ fontSize: 16 }} />
            </button>
          </span>
        ])}
      />

      {patientToDelete && (
        <div onClick={() => setPatientToDelete(null)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#ffffff', borderRadius: 12, width: '90%', maxWidth: 400, padding: 24, boxShadow: '0 8px 30px rgba(0,0,0,0.18)' }}>
            <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--color-text-primary)', marginBottom: 8 }}>Supprimer ce patient ?</div>
            <div style={{ fontSize: 13, color: 'var(--color-text-secondary)', marginBottom: 20, lineHeight: 1.5 }}>
              <b>{patientToDelete.first_name} {patientToDelete.last_name}</b> sera definitivement supprime. Cette action est irreversible.
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setPatientToDelete(null)} style={{ fontSize: 13, padding: '8px 16px', borderRadius: 8, border: '0.5px solid var(--color-border-tertiary)', background: '#fff', color: 'var(--color-text-secondary)', cursor: 'pointer' }}>Annuler</button>
              <button onClick={doDelete} style={{ fontSize: 13, padding: '8px 16px', borderRadius: 8, border: 'none', background: '#A32D2D', color: '#fff', cursor: 'pointer' }}>Supprimer</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function ORTab() {
  const [ops, setOps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ patient_id: '', procedure_name: '', scheduled_at: '', duration_minutes: 60, room_number: '', anesthesia_type: '', notes: '' });

  useEffect(() => { load(); }, []);
  const load = async () => {
    try { const r = await axios.get(`${API_URL}/api/pro/or`, getAuthConfig()); setOps(r.data.operations || []); }
    catch (e) {} finally { setLoading(false); }
  };
  const save = async () => {
    try { await axios.post(`${API_URL}/api/pro/or`, form, getAuthConfig()); setShowForm(false); load(); }
    catch (e) { alert('Erreur'); }
  };

  if (loading) return <div style={{ textAlign: 'center', padding: 40, color: 'var(--color-text-tertiary)' }}>Chargement...</div>;

  return (
    <div>
      <SectionHeader title="Bloc opératoire" action="Planifier une intervention" onClick={() => setShowForm(true)} />
      {showForm && (
        <FormCard title="Nouvelle intervention" onSave={save} onCancel={() => setShowForm(false)}>
          <InputField placeholder="ID Patient *" value={form.patient_id} onChange={e => setForm({...form, patient_id: e.target.value})} />
          <InputField placeholder="Nom de l'intervention *" value={form.procedure_name} onChange={e => setForm({...form, procedure_name: e.target.value})} />
          <InputField type="datetime-local" value={form.scheduled_at} onChange={e => setForm({...form, scheduled_at: e.target.value})} />
          <InputField placeholder="Durée (min)" type="number" value={form.duration_minutes} onChange={e => setForm({...form, duration_minutes: parseInt(e.target.value)})} />
          <InputField placeholder="Salle de bloc" value={form.room_number} onChange={e => setForm({...form, room_number: e.target.value})} />
          <SelectField value={form.anesthesia_type} onChange={e => setForm({...form, anesthesia_type: e.target.value})} options={[
            {value:'',label:"Type d'anesthésie"},{value:'generale',label:'Générale'},{value:'locale',label:'Locale'},
            {value:'locoregionale',label:'Loco-régionale'},{value:'rachianesthesie',label:'Rachianesthésie'},
          ]} />
        </FormCard>
      )}
      <TableWrap
        headers={['Intervention', 'Patient', 'Date/Heure', 'Durée', 'Salle', 'Anesthésie', 'Statut']}
        rows={ops.map(o => [
          <span style={{ fontWeight: 500 }}>{o.procedure_name}</span>,
          o.patient_id,
          new Date(o.scheduled_at).toLocaleString('fr-FR'),
          `${o.duration_minutes} min`,
          o.room_number || '—',
          o.anesthesia_type || '—',
          <Pill label={o.status === 'scheduled' ? 'Planifiée' : o.status === 'completed' ? 'Terminée' : o.status === 'in_progress' ? 'En cours' : 'Annulée'}
            type={o.status === 'completed' ? 'success' : o.status === 'in_progress' ? 'warning' : o.status === 'cancelled' ? 'danger' : 'info'} />
        ])}
      />
    </div>
  );
}

function LabTab() {
  const [patientSearch, setPatientSearch] = useState('');
  const [patients, setPatients] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedBilan, setSelectedBilan] = useState(null);
  const [analyses, setAnalyses] = useState([]);
  const [bilans, setBilans] = useState([]);
  const [preleveur, setPreleveur] = useState('');
  const [datetime, setDatetime] = useState('');
  const [saving, setSaving] = useState(false);
  const [clinic, setClinic] = useState(null);

  useEffect(() => {
    axios.get(API_URL + '/api/clinic/profile', getAuthConfig()).then(r => setClinic(r.data)).catch(() => {});
  }, []);

  const BILANS = {
    'NFS complete': [
      {name:'Hemoglobine (Hb)', unit:'g/dL', normal_f:'12.0 - 16.0', normal_m:'13.5 - 17.5'},
      {name:'Globules blancs (GB)', unit:'10³/µL', normal_f:'4.0 - 10.0', normal_m:'4.0 - 10.0'},
      {name:'Plaquettes', unit:'10³/µL', normal_f:'150 - 400', normal_m:'150 - 400'},
      {name:'Hematocrite (Ht)', unit:'%', normal_f:'36 - 46', normal_m:'40 - 54'},
      {name:'VGM', unit:'fL', normal_f:'80 - 100', normal_m:'80 - 100'},
      {name:'CCMH', unit:'g/dL', normal_f:'32 - 36', normal_m:'32 - 36'},
    ],
    'Bilan hepatique': [
      {name:'ASAT (TGO)', unit:'UI/L', normal_f:'< 35', normal_m:'< 40'},
      {name:'ALAT (TGP)', unit:'UI/L', normal_f:'< 35', normal_m:'< 45'},
      {name:'Gamma-GT', unit:'UI/L', normal_f:'< 38', normal_m:'< 55'},
      {name:'Phosphatases alcalines', unit:'UI/L', normal_f:'35 - 105', normal_m:'35 - 105'},
      {name:'Bilirubine totale', unit:'mg/L', normal_f:'2 - 10', normal_m:'2 - 10'},
      {name:'Bilirubine directe', unit:'mg/L', normal_f:'< 2', normal_m:'< 2'},
      {name:'Albumine', unit:'g/L', normal_f:'35 - 50', normal_m:'35 - 50'},
    ],
    'Bilan renal': [
      {name:'Creatinine', unit:'mg/L', normal_f:'6 - 11', normal_m:'7 - 13'},
      {name:'Uree', unit:'g/L', normal_f:'0.15 - 0.45', normal_m:'0.15 - 0.45'},
      {name:'Acide urique', unit:'mg/L', normal_f:'20 - 60', normal_m:'35 - 70'},
      {name:'DFG (CKD-EPI)', unit:'mL/min/1.73m²', normal_f:'> 60', normal_m:'> 60'},
    ],
    'Bilan lipidique': [
      {name:'Cholesterol total', unit:'g/L', normal_f:'< 2.0', normal_m:'< 2.0'},
      {name:'HDL-cholesterol', unit:'g/L', normal_f:'> 0.50', normal_m:'> 0.40'},
      {name:'LDL-cholesterol', unit:'g/L', normal_f:'< 1.30', normal_m:'< 1.30'},
      {name:'Triglycerides', unit:'g/L', normal_f:'< 1.50', normal_m:'< 1.50'},
    ],
    'Glycemie / HbA1c': [
      {name:'Glycemie a jeun', unit:'g/L', normal_f:'0.70 - 1.10', normal_m:'0.70 - 1.10'},
      {name:'HbA1c', unit:'%', normal_f:'< 5.7', normal_m:'< 5.7'},
      {name:'Insulinemie', unit:'µUI/mL', normal_f:'2 - 25', normal_m:'2 - 25'},
    ],
    'Bilan thyroidien': [
      {name:'TSH', unit:'mUI/L', normal_f:'0.4 - 4.0', normal_m:'0.4 - 4.0'},
      {name:'T4 libre (FT4)', unit:'pmol/L', normal_f:'10 - 20', normal_m:'10 - 20'},
      {name:'T3 libre (FT3)', unit:'pmol/L', normal_f:'3.5 - 6.5', normal_m:'3.5 - 6.5'},
    ],
    'Ionogramme': [
      {name:'Sodium (Na)', unit:'mEq/L', normal_f:'135 - 145', normal_m:'135 - 145'},
      {name:'Potassium (K)', unit:'mEq/L', normal_f:'3.5 - 5.0', normal_m:'3.5 - 5.0'},
      {name:'Chlore (Cl)', unit:'mEq/L', normal_f:'95 - 105', normal_m:'95 - 105'},
      {name:'Bicarbonates', unit:'mEq/L', normal_f:'22 - 29', normal_m:'22 - 29'},
      {name:'Calcium (Ca)', unit:'mg/L', normal_f:'85 - 105', normal_m:'85 - 105'},
      {name:'Phosphore', unit:'mg/L', normal_f:'25 - 45', normal_m:'25 - 45'},
    ],
    'Coagulation': [
      {name:'TP (Taux de prothrombine)', unit:'%', normal_f:'70 - 100', normal_m:'70 - 100'},
      {name:'TCA', unit:'sec', normal_f:'25 - 35', normal_m:'25 - 35'},
      {name:'Fibrinogene', unit:'g/L', normal_f:'2.0 - 4.0', normal_m:'2.0 - 4.0'},
      {name:'INR', unit:'', normal_f:'0.8 - 1.2', normal_m:'0.8 - 1.2'},
    ],
    'Marqueurs infection': [
      {name:'CRP (Proteine C reactive)', unit:'mg/L', normal_f:'< 6', normal_m:'< 6'},
      {name:'VS (1ere heure)', unit:'mm/h', normal_f:'< 20', normal_m:'< 15'},
      {name:'Procalcitonine (PCT)', unit:'ng/mL', normal_f:'< 0.5', normal_m:'< 0.5'},
    ],
    'Bilan cardiaque': [
      {name:'Troponine I', unit:'ng/L', normal_f:'< 16', normal_m:'< 34'},
      {name:'CK-MB', unit:'UI/L', normal_f:'< 25', normal_m:'< 25'},
      {name:'BNP', unit:'pg/mL', normal_f:'< 100', normal_m:'< 100'},
      {name:'LDH', unit:'UI/L', normal_f:'140 - 280', normal_m:'140 - 280'},
    ],
    'Bilan martial': [
      {name:'Fer serique', unit:'µg/dL', normal_f:'60 - 160', normal_m:'70 - 175'},
      {name:'Ferritine', unit:'ng/mL', normal_f:'12 - 150', normal_m:'30 - 300'},
      {name:'Transferrine', unit:'g/L', normal_f:'2.0 - 3.6', normal_m:'2.0 - 3.6'},
      {name:'Coefficient de saturation', unit:'%', normal_f:'20 - 40', normal_m:'20 - 40'},
    ],
  };

  const searchPatients = async () => {
    if (!patientSearch.trim()) return;
    try {
      const r = await axios.get(API_URL + '/api/clinic/patients?search=' + encodeURIComponent(patientSearch), getAuthConfig());
      setPatients(r.data.patients || []);
    } catch(e) { setPatients([]); }
  };

  const selectPatient = (p) => {
    setSelectedPatient(p);
    setPatients([]);
    setPatientSearch(p.first_name + ' ' + p.last_name);
    loadBilans(p.clinic_patient_id || p.patient_id);
  };

  const loadBilans = async (pid) => {
    try {
      const r = await axios.get(API_URL + '/api/pro/lab/bilans/' + pid, getAuthConfig());
      setBilans(r.data.bilans || []);
    } catch(e) {}
  };

  const selectBilan = (bilanName) => {
    setSelectedBilan(bilanName);
    const sex = selectedPatient?.gender === 'female' ? 'f' : 'm';
    const items = (BILANS[bilanName] || []).map(a => ({
      ...a,
      result: '',
      normal: sex === 'f' ? a.normal_f : a.normal_m,
      is_abnormal: false,
      comment: '',
    }));
    setAnalyses(items);
  };

  const updateResult = (i, value) => {
    const updated = [...analyses];
    updated[i].result = value;
    const normal = updated[i].normal || '';
    if (value && normal) {
      const v = parseFloat(value);
      if (!isNaN(v)) {
        const ltMatch = normal.match(/^< ?([\d.]+)/);
        const gtMatch = normal.match(/^> ?([\d.]+)/);
        const rangeMatch = normal.match(/([\d.]+)\s*-\s*([\d.]+)/);
        let isAbnormal = false;
        let autoComment = '';
        if (ltMatch) {
          isAbnormal = v >= parseFloat(ltMatch[1]);
          if (isAbnormal) autoComment = 'Valeur elevee (' + v + ') — limite: < ' + ltMatch[1];
        } else if (gtMatch) {
          isAbnormal = v <= parseFloat(gtMatch[1]);
          if (isAbnormal) autoComment = 'Valeur basse (' + v + ') — limite: > ' + gtMatch[1];
        } else if (rangeMatch) {
          const min = parseFloat(rangeMatch[1]);
          const max = parseFloat(rangeMatch[2]);
          if (v < min) { isAbnormal = true; autoComment = 'Valeur basse (' + v + ') — normale: ' + min + '-' + max; }
          else if (v > max) { isAbnormal = true; autoComment = 'Valeur elevee (' + v + ') — normale: ' + min + '-' + max; }
        }
        updated[i].is_abnormal = isAbnormal;
        updated[i].comment = isAbnormal ? autoComment : '';
      }
    }
    setAnalyses(updated);
  };

  const toggleAbnormal = (i) => {
    const updated = [...analyses];
    updated[i].is_abnormal = !updated[i].is_abnormal;
    setAnalyses(updated);
  };

  const updateComment = (i, value) => {
    const updated = [...analyses];
    updated[i].comment = value;
    setAnalyses(updated);
  };

  const save = async () => {
    if (!selectedPatient) { alert('Selectionnez un patient'); return; }
    if (!selectedBilan) { alert('Selectionnez un bilan'); return; }
    const filledAnalyses = analyses.filter(a => a.result !== '');
    if (filledAnalyses.length === 0) { alert('Entrez au moins un resultat'); return; }
    setSaving(true);
    try {
      const pid = selectedPatient.clinic_patient_id || selectedPatient.patient_id;
      await axios.post(API_URL + '/api/pro/lab/bilan', {
        patient_id: pid,
        patient_name: selectedPatient.first_name + ' ' + selectedPatient.last_name,
        bilan_name: selectedBilan,
        preleveur: preleveur,
        performed_at: datetime || new Date().toISOString(),
        analyses: filledAnalyses.map(a => ({
          test_name: a.name,
          result_value: a.result,
          unit: a.unit,
          reference_range: a.normal,
          is_abnormal: a.is_abnormal,
          notes: a.comment,
        })),
      }, getAuthConfig());
      alert('Bilan enregistre avec succes');
      setSelectedBilan(null);
      setAnalyses([]);
      loadBilans(pid);
    } catch(e) { alert('Erreur lors de l enregistrement'); }
    finally { setSaving(false); }
  };

  const fieldStyle = { padding: '8px 12px', border: '0.5px solid #CBD5E1', borderRadius: 8, fontSize: 13, background: 'var(--color-background-primary)', color: 'var(--color-text-primary)', outline: 'none' };

  return (
    <div>
      <SectionHeader title="Laboratoire d'analyses" />

      <div style={{ background: 'var(--color-background-primary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, padding: 20, marginBottom: 16 }}>
        <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 12 }}>Recherche patient</div>
        <div style={{ display: 'flex', gap: 10, marginBottom: 8 }}>
          <input style={{ ...fieldStyle, flex: 1 }} placeholder="Nom, prenom ou telephone..."
            value={patientSearch} onChange={e => setPatientSearch(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && searchPatients()} />
          <button onClick={searchPatients} style={{ padding: '8px 18px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
            Rechercher
          </button>
        </div>

        {patients.length > 0 && (
          <div style={{ border: '0.5px solid var(--color-border-tertiary)', borderRadius: 8, overflow: 'hidden', marginBottom: 8 }}>
            {patients.map((p, i) => (
              <div key={i} onClick={() => selectPatient(p)}
                style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: i < patients.length-1 ? '0.5px solid var(--color-border-tertiary)' : 'none', display: 'flex', justifyContent: 'space-between' }}
                onMouseEnter={e => e.currentTarget.style.background='var(--color-background-secondary)'}
                onMouseLeave={e => e.currentTarget.style.background='transparent'}>
                <span style={{ fontWeight: 500, fontSize: 13 }}>{p.first_name} {p.last_name}</span>
                <span style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>{p.phone || ''}</span>
              </div>
            ))}
          </div>
        )}

        {selectedPatient && (
          <div style={{ background: '#E6F1FB', border: '0.5px solid #B5D4F4', borderRadius: 10, padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{ width: 42, height: 42, borderRadius: '50%', background: '#185FA5', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 14, fontWeight: 500, flexShrink: 0 }}>
              {(selectedPatient.first_name?.[0] || '') + (selectedPatient.last_name?.[0] || '')}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 500, color: '#0C447C' }}>{selectedPatient.first_name} {selectedPatient.last_name}</div>
              <div style={{ fontSize: 12, color: '#185FA5', marginTop: 2 }}>
                {selectedPatient.gender === 'female' ? 'F' : 'M'}
                {selectedPatient.date_of_birth ? ' — ' + (new Date().getFullYear() - new Date(selectedPatient.date_of_birth).getFullYear()) + ' ans' : ''}
                {selectedPatient.phone ? ' — ' + selectedPatient.phone : ''}
              </div>
            </div>
            <button onClick={() => { setSelectedPatient(null); setPatientSearch(''); setSelectedBilan(null); setAnalyses([]); setBilans([]); }}
              style={{ background: 'none', border: 'none', color: '#185FA5', cursor: 'pointer', fontSize: 18 }}>x</button>
          </div>
        )}
      </div>

      {selectedPatient && (
        <div style={{ background: 'var(--color-background-primary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, padding: 20, marginBottom: 16 }}>
          <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--color-text-secondary)', marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
            Bilans predefinies — selectionner pour saisir les resultats
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 6 }}>
            {Object.keys(BILANS).map(b => (
              <button key={b} onClick={() => selectBilan(b)}
                style={{ padding: '10px', border: selectedBilan === b ? '2px solid #185FA5' : '0.5px solid var(--color-border-tertiary)', borderRadius: 8, fontSize: 12, cursor: 'pointer', textAlign: 'center', background: selectedBilan === b ? '#E6F1FB' : 'var(--color-background-primary)', color: selectedBilan === b ? '#0C447C' : 'var(--color-text-primary)', fontWeight: selectedBilan === b ? 500 : 400 }}>
                {b}
              </button>
            ))}
          </div>
        </div>
      )}

      {analyses.length > 0 && (
        <div style={{ background: 'var(--color-background-primary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, overflow: 'hidden', marginBottom: 16 }}>
          <div style={{ padding: '12px 16px', borderBottom: '0.5px solid var(--color-border-tertiary)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#F8FAFC' }}>
            <div style={{ fontSize: 13, fontWeight: 500 }}>{selectedBilan} — {analyses.length} analyses</div>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
            <thead style={{ background: '#185FA5' }}>
              <tr>
                {['Analyse', 'Resultat', 'Unite', 'Valeurs normales', 'Statut', 'Commentaire'].map(h => (
                  <th key={h} style={{ padding: '10px 14px', textAlign: 'left', color: '#fff', fontWeight: 500 }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {analyses.map((a, i) => (
                <tr key={i} style={{ borderBottom: '0.5px solid var(--color-border-tertiary)', background: i % 2 === 0 ? '#fff' : '#F8FAFC' }}>
                  <td style={{ padding: '10px 14px', fontWeight: 500 }}>{a.name}</td>
                  <td style={{ padding: '10px 14px' }}>
                    <input type="number" value={a.result} onChange={e => updateResult(i, e.target.value)}
                      style={{ width: 90, padding: '6px 10px', border: '2px solid ' + (a.is_abnormal ? '#E24B4A' : '#185FA5'), borderRadius: 8, fontSize: 14, textAlign: 'center', background: a.is_abnormal ? '#FCEBEB' : '#EFF6FF', color: a.is_abnormal ? '#A32D2D' : '#185FA5', fontWeight: 500, outline: 'none' }} />
                  </td>
                  <td style={{ padding: '10px 14px', color: 'var(--color-text-secondary)' }}>{a.unit}</td>
                  <td style={{ padding: '10px 14px', color: 'var(--color-text-secondary)' }}>{a.normal}</td>
                  <td style={{ padding: '10px 14px' }}>
                    <button onClick={() => toggleAbnormal(i)}
                      style={{ fontSize: 11, padding: '3px 10px', borderRadius: 20, border: 'none', cursor: 'pointer', background: a.is_abnormal ? '#FCEBEB' : '#EAF3DE', color: a.is_abnormal ? '#A32D2D' : '#3B6D11', fontWeight: 500 }}>
                      {a.is_abnormal ? 'ANORMAL' : 'Normal'}
                    </button>
                  </td>
                  <td style={{ padding: '10px 14px' }}>
                    <input type="text" value={a.comment} onChange={e => updateComment(i, e.target.value)}
                      placeholder="Commentaire..."
                      style={{ width: '100%', padding: '5px 8px', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 6, fontSize: 12, background: 'var(--color-background-primary)', color: 'var(--color-text-primary)' }} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ padding: '12px 16px', borderTop: '0.5px solid var(--color-border-tertiary)', display: 'flex', alignItems: 'center', gap: 16, background: '#F8FAFC' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>Preleveur :</span>
              <input value={preleveur} onChange={e => setPreleveur(e.target.value)} placeholder="Nom du preleveur"
                style={{ ...fieldStyle, padding: '5px 10px', width: 160 }} />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>Date/heure :</span>
              <input type="datetime-local" value={datetime} onChange={e => setDatetime(e.target.value)}
                style={{ ...fieldStyle, padding: '5px 10px' }} />
            </div>
            <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
              <button onClick={() => { setSelectedBilan(null); setAnalyses([]); }}
                style={{ padding: '7px 16px', border: '0.5px solid var(--color-border-secondary)', borderRadius: 8, fontSize: 13, cursor: 'pointer', background: 'transparent' }}>
                Annuler
              </button>
              <button onClick={save} disabled={saving}
                style={{ padding: '7px 16px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500, opacity: saving ? 0.7 : 1 }}>
                {saving ? 'Enregistrement...' : 'Enregistrer le bilan'}
              </button>
            </div>
          </div>
        </div>
      )}

      {bilans.length > 0 && (
        <div>
          <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 12 }}>Historique des bilans</div>
          {bilans.map((b, bi) => (
            <div key={b.bilan_id} style={{ border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, overflow: 'hidden', marginBottom: 12 }}>
              <div style={{ padding: '12px 16px', background: '#F8FAFC', borderBottom: '0.5px solid var(--color-border-tertiary)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <span style={{ fontWeight: 500, fontSize: 13 }}>{b.bilan_name}</span>
                  <span style={{ fontSize: 12, color: 'var(--color-text-secondary)', marginLeft: 12 }}>
                    {new Date(b.performed_at).toLocaleDateString('fr-FR')} a {new Date(b.performed_at).toLocaleTimeString('fr-FR', {hour:'2-digit', minute:'2-digit'})}
                    {b.preleveur && ' — Preleveur : ' + b.preleveur}
                  </span>
                  {b.analyses && b.analyses.some(a => a.is_abnormal) && (
                    <span style={{ marginLeft: 10, fontSize: 11, background: '#FCEBEB', color: '#A32D2D', padding: '2px 8px', borderRadius: 20 }}>
                      {b.analyses.filter(a => a.is_abnormal).length} anormal(aux)
                    </span>
                  )}
                </div>
                <button onClick={() => generateLabPDF(clinic?.name, b.patient_name || patientSearch, b.bilan_name, b.analyses || [])}
                  style={{ padding: '5px 12px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 6, fontSize: 12, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 5 }}>
                  <i className="ti ti-printer" style={{ fontSize: 14 }} /> Imprimer
                </button>
              </div>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead style={{ background: '#185FA5' }}>
                  <tr>
                    {['Analyse', 'Resultat', 'Unite', 'Valeurs normales', 'Statut', 'Commentaire'].map(h => (
                      <th key={h} style={{ padding: '8px 14px', textAlign: 'left', color: '#fff', fontWeight: 500 }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(b.analyses || []).map((a, i) => (
                    <tr key={i} style={{ borderBottom: '0.5px solid var(--color-border-tertiary)', background: i % 2 === 0 ? '#fff' : '#F8FAFC' }}>
                      <td style={{ padding: '8px 14px', fontWeight: 500 }}>{a.test_name}</td>
                      <td style={{ padding: '8px 14px', fontWeight: 600, color: a.is_abnormal ? '#A32D2D' : '#3B6D11' }}>{a.result_value}</td>
                      <td style={{ padding: '8px 14px', color: 'var(--color-text-secondary)' }}>{a.unit}</td>
                      <td style={{ padding: '8px 14px', color: 'var(--color-text-secondary)' }}>{a.reference_range}</td>
                      <td style={{ padding: '8px 14px' }}>
                        <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 20, background: a.is_abnormal ? '#FCEBEB' : '#EAF3DE', color: a.is_abnormal ? '#A32D2D' : '#3B6D11', fontWeight: 500 }}>
                          {a.is_abnormal ? 'ANORMAL' : 'Normal'}
                        </span>
                      </td>
                      <td style={{ padding: '8px 14px', color: a.is_abnormal ? '#A32D2D' : 'var(--color-text-secondary)' }}>{a.notes || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      )}

      {selectedPatient && bilans.length === 0 && !selectedBilan && (
        <div style={{ textAlign: 'center', padding: 32, color: 'var(--color-text-tertiary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10 }}>
          Aucun bilan enregistre pour ce patient
        </div>
      )}

      {!selectedPatient && (
        <div style={{ textAlign: 'center', padding: 40, color: 'var(--color-text-tertiary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10 }}>
          <i className="ti ti-microscope" style={{ fontSize: 32, display: 'block', marginBottom: 8 }} aria-hidden="true" />
          Recherchez un patient pour commencer
        </div>
      )}
    </div>
  );
}

function ImagingTab() {
  const [patientSearch, setPatientSearch] = useState('');
  const [patients, setPatients] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [history, setHistory] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    exam_type: 'radio', body_part: '', side: '',
    requesting_doctor: '', performed_at: '',
    indication: '', technique: '', results: '', conclusion: '',
    notes: ''
  });

  const EXAM_TYPES = [
    {value:'radio', label:'Radiographie', icon:'ti-radioactive'},
    {value:'scanner', label:'Scanner (TDM)', icon:'ti-scan'},
    {value:'irm', label:'IRM', icon:'ti-device-analytics'},
    {value:'echo', label:'Echographie', icon:'ti-activity-heartbeat'},
    {value:'mammographie', label:'Mammographie', icon:'ti-camera'},
    {value:'pet_scan', label:'PET-Scan', icon:'ti-atom'},
    {value:'scintigraphie', label:'Scintigraphie', icon:'ti-radioactive'},
    {value:'autre', label:'Autre', icon:'ti-file-medical'},
  ];

  const BODY_PARTS = [
    'Thorax','Abdomen','Pelvis','Abdomen-Pelvis','Crane','Rachis cervical',
    'Rachis dorsal','Rachis lombaire','Epaule droite','Epaule gauche',
    'Bras droit','Bras gauche','Avant-bras droit','Avant-bras gauche',
    'Main droite','Main gauche','Hanche droite','Hanche gauche',
    'Genou droit','Genou gauche','Jambe droite','Jambe gauche',
    'Cheville droite','Cheville gauche','Pied droit','Pied gauche',
    'Coeur','Vaisseaux','Sein droit','Sein gauche','Seins bilateral',
    'Thyroide','Foie','Vesicule biliaire','Reins','Prostate','Uterus',
  ];

  const searchPatients = async () => {
    if (!patientSearch.trim()) return;
    try {
      const r = await axios.get(API_URL + '/api/clinic/patients?search=' + encodeURIComponent(patientSearch), getAuthConfig());
      setPatients(r.data.patients || []);
    } catch(e) { setPatients([]); }
  };

  const selectPatient = (p) => {
    setSelectedPatient(p);
    setPatients([]);
    setPatientSearch(p.first_name + ' ' + p.last_name);
    loadHistory(p.clinic_patient_id || p.patient_id);
  };

  const loadHistory = async (pid) => {
    try {
      const r = await axios.get(API_URL + '/api/pro/imaging/' + pid, getAuthConfig());
      setHistory(r.data.images || []);
    } catch(e) {}
  };

  const save = async () => {
    if (!selectedPatient) { alert('Selectionnez un patient'); return; }
    if (!form.body_part) { alert('La zone anatomique est obligatoire'); return; }
    setSaving(true);
    try {
      await axios.post(API_URL + '/api/pro/imaging', {
        ...form,
        patient_id: selectedPatient.clinic_patient_id || selectedPatient.patient_id,
        performed_at: form.performed_at || new Date().toISOString(),
      }, getAuthConfig());
      alert('Examen enregistre avec succes');
      setShowForm(false);
      setForm({ exam_type: 'radio', body_part: '', side: '', requesting_doctor: '', performed_at: '', indication: '', technique: '', results: '', conclusion: '', notes: '' });
      loadHistory(selectedPatient.clinic_patient_id || selectedPatient.patient_id);
    } catch(e) { alert('Erreur'); }
    finally { setSaving(false); }
  };

  const examTypeLabel = (v) => EXAM_TYPES.find(e => e.value === v)?.label || v;
  const examTypeIcon = (v) => EXAM_TYPES.find(e => e.value === v)?.icon || 'ti-file-medical';

  const inputStyle = { width: '100%', padding: '8px 12px', border: '0.5px solid #CBD5E1', borderRadius: 8, fontSize: 13, color: 'var(--color-text-primary)', background: 'var(--color-background-primary)', outline: 'none' };
  const labelStyle = { fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4, display: 'block' };

  return (
    <div>
      <SectionHeader title="Imagerie medicale" action={selectedPatient ? "Nouvel examen" : null} onClick={() => setShowForm(!showForm)} />

      <div style={{ background: 'var(--color-background-primary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, padding: 20, marginBottom: 16 }}>
        <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 12 }}>Recherche patient</div>
        <div style={{ display: 'flex', gap: 10, marginBottom: 8 }}>
          <input style={{ ...inputStyle, flex: 1 }} placeholder="Nom, prenom ou telephone du patient..."
            value={patientSearch} onChange={e => setPatientSearch(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && searchPatients()} />
          <button onClick={searchPatients} style={{ padding: '8px 18px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
            Rechercher
          </button>
        </div>

        {patients.length > 0 && (
          <div style={{ border: '0.5px solid var(--color-border-tertiary)', borderRadius: 8, overflow: 'hidden', marginBottom: 8 }}>
            {patients.map((p, i) => (
              <div key={i} onClick={() => selectPatient(p)}
                style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: i < patients.length-1 ? '0.5px solid var(--color-border-tertiary)' : 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                onMouseEnter={e => e.currentTarget.style.background='var(--color-background-secondary)'}
                onMouseLeave={e => e.currentTarget.style.background='transparent'}>
                <div>
                  <span style={{ fontWeight: 500, fontSize: 13 }}>{p.first_name} {p.last_name}</span>
                  <span style={{ fontSize: 12, color: 'var(--color-text-secondary)', marginLeft: 10 }}>{p.phone || ''}</span>
                </div>
                <span style={{ fontSize: 11, color: 'var(--color-text-tertiary)' }}>
                  {p.date_of_birth ? new Date().getFullYear() - new Date(p.date_of_birth).getFullYear() + ' ans' : ''}
                </span>
              </div>
            ))}
          </div>
        )}

        {selectedPatient && (
          <div style={{ background: '#E6F1FB', border: '0.5px solid #B5D4F4', borderRadius: 10, padding: '12px 16px', display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{ width: 42, height: 42, borderRadius: '50%', background: '#185FA5', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 14, fontWeight: 500, flexShrink: 0 }}>
              {(selectedPatient.first_name?.[0] || '') + (selectedPatient.last_name?.[0] || '')}
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 14, fontWeight: 500, color: '#0C447C' }}>{selectedPatient.first_name} {selectedPatient.last_name}</div>
              <div style={{ fontSize: 12, color: '#185FA5', marginTop: 2 }}>
                {selectedPatient.gender === 'female' ? 'F' : 'M'}
                {selectedPatient.date_of_birth ? ' — ' + (new Date().getFullYear() - new Date(selectedPatient.date_of_birth).getFullYear()) + ' ans' : ''}
                {selectedPatient.phone ? ' — ' + selectedPatient.phone : ''}
              </div>
            </div>
            <button onClick={() => { setSelectedPatient(null); setPatientSearch(''); setHistory([]); setShowForm(false); }}
              style={{ background: 'none', border: 'none', color: '#185FA5', cursor: 'pointer', fontSize: 18 }}>x</button>
          </div>
        )}
      </div>

      {selectedPatient && showForm && (
        <div style={{ background: 'var(--color-background-primary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, padding: 20, marginBottom: 16 }}>
          <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 16, paddingBottom: 12, borderBottom: '0.5px solid var(--color-border-tertiary)' }}>
            Nouvel examen d'imagerie
          </div>

          <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--color-text-secondary)', marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Type d'examen</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 8, marginBottom: 16 }}>
            {EXAM_TYPES.map(e => (
              <button key={e.value} onClick={() => setForm({...form, exam_type: e.value})}
                style={{ padding: '12px 8px', border: form.exam_type === e.value ? '0.5px solid #B5D4F4' : '0.5px solid var(--color-border-tertiary)', borderRadius: 10, fontSize: 12, cursor: 'pointer', textAlign: 'center', background: form.exam_type === e.value ? '#E6F1FB' : 'var(--color-background-primary)', color: form.exam_type === e.value ? '#0C447C' : 'var(--color-text-primary)', fontWeight: form.exam_type === e.value ? 500 : 400 }}>
                <i className={'ti ' + e.icon} style={{ fontSize: 20, display: 'block', marginBottom: 6, color: form.exam_type === e.value ? '#185FA5' : 'var(--color-text-secondary)' }} aria-hidden="true" />
                {e.label}
              </button>
            ))}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px 16px', marginBottom: 16 }}>
            <div>
              <label style={labelStyle}>Zone anatomique *</label>
              <select value={form.body_part} onChange={e => setForm({...form, body_part: e.target.value})} style={inputStyle}>
                <option value="">Selectionner...</option>
                {BODY_PARTS.map(b => <option key={b} value={b}>{b}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Cote</label>
              <select value={form.side} onChange={e => setForm({...form, side: e.target.value})} style={inputStyle}>
                <option value="">Non applicable</option>
                <option value="droit">Droit(e)</option>
                <option value="gauche">Gauche</option>
                <option value="bilateral">Bilateral</option>
              </select>
            </div>
            <div>
              <label style={labelStyle}>Medecin demandeur</label>
              <input style={inputStyle} placeholder="Nom du medecin" value={form.requesting_doctor} onChange={e => setForm({...form, requesting_doctor: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>Date et heure de l'examen</label>
              <input type="datetime-local" style={inputStyle} value={form.performed_at} onChange={e => setForm({...form, performed_at: e.target.value})} />
            </div>
          </div>

          <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--color-text-secondary)', marginBottom: 12, textTransform: 'uppercase', letterSpacing: '0.04em', paddingTop: 8, borderTop: '0.5px solid var(--color-border-tertiary)' }}>
            Compte-rendu radiologique
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: 12, marginBottom: 16 }}>
            <div>
              <label style={labelStyle}>Indication clinique</label>
              <textarea style={{ ...inputStyle, resize: 'vertical', minHeight: 60 }} placeholder="Motif de l'examen, contexte clinique, renseignements pertinents..." value={form.indication} onChange={e => setForm({...form, indication: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>Technique</label>
              <textarea style={{ ...inputStyle, resize: 'vertical', minHeight: 60 }} placeholder="Technique utilisee, incidences, produit de contraste, dose..." value={form.technique} onChange={e => setForm({...form, technique: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>Resultats / Description des images</label>
              <textarea style={{ ...inputStyle, resize: 'vertical', minHeight: 100 }} placeholder="Description detaillee des images, anomalies observees, mesures..." value={form.results} onChange={e => setForm({...form, results: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>Conclusion</label>
              <textarea style={{ ...inputStyle, resize: 'vertical', minHeight: 70, border: '1.5px solid #B5D4F4', background: '#F8FBFF' }} placeholder="Conclusion diagnostique, recommandations, suivi propose..." value={form.conclusion} onChange={e => setForm({...form, conclusion: e.target.value})} />
            </div>
          </div>

          <div style={{ display: 'flex', gap: 8, paddingTop: 12, borderTop: '0.5px solid var(--color-border-tertiary)' }}>
            <button onClick={save} disabled={saving}
              style={{ padding: '8px 20px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500, opacity: saving ? 0.7 : 1 }}>
              {saving ? 'Enregistrement...' : "Enregistrer l'examen"}
            </button>
            <button onClick={() => setShowForm(false)}
              style={{ padding: '8px 20px', background: 'transparent', border: '0.5px solid var(--color-border-secondary)', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
              Annuler
            </button>
          </div>
        </div>
      )}

      {selectedPatient && !showForm && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--color-text-primary)', marginBottom: 12 }}>
            Historique des examens
          </div>
          {history.length === 0 ? (
            <div style={{ textAlign: 'center', padding: 32, color: 'var(--color-text-tertiary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10 }}>
              <i className="ti ti-radio" style={{ fontSize: 32, display: 'block', marginBottom: 8 }} aria-hidden="true" />
              Aucun examen d'imagerie pour ce patient
            </div>
          ) : (
            <div style={{ border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, overflow: 'hidden' }}>
              {history.map((img, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 14, padding: '14px 16px', borderBottom: i < history.length-1 ? '0.5px solid var(--color-border-tertiary)' : 'none' }}>
                  <div style={{ width: 40, height: 40, borderRadius: 8, background: '#E6F1FB', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#185FA5', flexShrink: 0 }}>
                    <i className={'ti ' + examTypeIcon(img.exam_type)} style={{ fontSize: 18 }} aria-hidden="true" />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <div>
                        <div style={{ fontSize: 13, fontWeight: 500 }}>{examTypeLabel(img.exam_type)} — {img.body_part}</div>
                        <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginTop: 2 }}>
                          {img.requesting_doctor && 'Dr. ' + img.requesting_doctor + ' — '}
                          {new Date(img.performed_at).toLocaleDateString('fr-FR')}
                        </div>
                      </div>
                      <span style={{ fontSize: 11, background: '#E6F1FB', color: '#185FA5', padding: '2px 8px', borderRadius: 20 }}>
                        {examTypeLabel(img.exam_type)}
                      </span>
                    </div>
                    {img.conclusion && (
                      <div style={{ marginTop: 8, padding: '8px 12px', background: '#F8FBFF', border: '0.5px solid #B5D4F4', borderRadius: 8, fontSize: 12, color: '#0C447C' }}>
                        <span style={{ fontWeight: 500 }}>Conclusion : </span>{img.conclusion}
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {!selectedPatient && (
        <div style={{ textAlign: 'center', padding: 40, color: 'var(--color-text-tertiary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10 }}>
          <i className="ti ti-radio" style={{ fontSize: 32, display: 'block', marginBottom: 8 }} aria-hidden="true" />
          Recherchez un patient pour commencer
        </div>
      )}
    </div>
  );
}

function PharmacyTab() {
  const [stock, setStock] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [search, setSearch] = useState('');
  const [form, setForm] = useState({
    name: '', commercial_name: '', category: 'antibiotique',
    form_type: 'comprime', dosage: '', route: 'orale',
    quantity: 0, unit_price: 0, min_stock: 10,
    lot: '', expiry_date: '', supplier: ''
  });

  useEffect(() => { load(); }, []);

  const load = async () => {
    try { const r = await axios.get(API_URL + '/api/pro/pharmacy', getAuthConfig()); setStock(r.data.stock || []); }
    catch (e) {} finally { setLoading(false); }
  };

  const save = async () => {
    if (!form.name) { alert('Le nom est obligatoire'); return; }
    try {
      await axios.post(API_URL + '/api/pro/pharmacy', form, getAuthConfig());
      setShowForm(false);
      setForm({ name: '', commercial_name: '', category: 'antibiotique', form_type: 'comprime', dosage: '', route: 'orale', quantity: 0, unit_price: 0, min_stock: 10, lot: '', expiry_date: '', supplier: '' });
      load();
    } catch (e) { alert('Erreur'); }
  };

  const del = async (id) => {
    if (!window.confirm('Supprimer ?')) return;
    try { await axios.delete(API_URL + '/api/pro/pharmacy/' + id, getAuthConfig()); load(); }
    catch (e) { alert('Erreur'); }
  };

  const isLow = (s) => s.quantity <= s.min_stock;
  const isExpired = (s) => s.expiry_date && new Date(s.expiry_date) < new Date();
  const isExpiringSoon = (s) => {
    if (!s.expiry_date) return false;
    const diff = (new Date(s.expiry_date) - new Date()) / (1000 * 60 * 60 * 24);
    return diff > 0 && diff <= 30;
  };

  const filtered = stock.filter(s =>
    (s.name + ' ' + (s.commercial_name || '') + ' ' + (s.category || '')).toLowerCase().includes(search.toLowerCase())
  );

  if (loading) return <div style={{ textAlign: 'center', padding: 40, color: 'var(--color-text-tertiary)' }}>Chargement...</div>;

  return (
    <div>
      <SectionHeader title="Pharmacie interne" action="Ajouter un medicament" onClick={() => setShowForm(!showForm)} />

      {showForm && (
        <div style={{ background: 'var(--color-background-primary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, padding: 20, marginBottom: 16 }}>
          <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 16, paddingBottom: 12, borderBottom: '0.5px solid var(--color-border-tertiary)' }}>Nouveau medicament</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px 16px', marginBottom: 16 }}>
            <div>
              <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4 }}>DCI (nom generique) *</div>
              <InputField placeholder="ex: Amoxicilline" value={form.name} onChange={e => setForm({...form, name: e.target.value})} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4 }}>Nom commercial</div>
              <InputField placeholder="ex: Amoxil, Clamoxyl" value={form.commercial_name} onChange={e => setForm({...form, commercial_name: e.target.value})} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4 }}>Categorie therapeutique</div>
              <SelectField value={form.category} onChange={e => setForm({...form, category: e.target.value})} options={[
                {value:'antibiotique',label:'Antibiotique'},{value:'analgesique',label:'Analgesique'},
                {value:'antihypertenseur',label:'Antihypertenseur'},{value:'antidiabetique',label:'Antidiabetique'},
                {value:'antiinflammatoire',label:'Anti-inflammatoire'},{value:'anticoagulant',label:'Anticoagulant'},
                {value:'cardiovasculaire',label:'Cardiovasculaire'},{value:'neurologie',label:'Neurologie'},
                {value:'gastroenterologie',label:'Gastroenterologie'},{value:'pneumologie',label:'Pneumologie'},
                {value:'dermatologie',label:'Dermatologie'},{value:'ophtalmologie',label:'Ophtalmologie'},
                {value:'autre',label:'Autre'},
              ]} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4 }}>Forme galenique</div>
              <SelectField value={form.form_type} onChange={e => setForm({...form, form_type: e.target.value})} options={[
                {value:'comprime',label:'Comprime'},{value:'gelule',label:'Gelule'},
                {value:'injectable',label:'Injectable (ampoule)'},{value:'sirop',label:'Sirop'},
                {value:'suspension',label:'Suspension buvable'},{value:'pommade',label:'Pommade/Creme'},
                {value:'gouttes',label:'Gouttes'},{value:'patch',label:'Patch transdermique'},
                {value:'suppositoire',label:'Suppositoire'},{value:'sachet',label:'Sachet'},
                {value:'flacon',label:'Flacon'},{value:'autre',label:'Autre'},
              ]} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4 }}>Dosage</div>
              <InputField placeholder="ex: 500mg, 1g, 250mg/5ml" value={form.dosage} onChange={e => setForm({...form, dosage: e.target.value})} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4 }}>Voie d'administration</div>
              <SelectField value={form.route} onChange={e => setForm({...form, route: e.target.value})} options={[
                {value:'orale',label:'Orale (per os)'},{value:'iv',label:'Intraveineuse (IV)'},
                {value:'im',label:'Intramusculaire (IM)'},{value:'sc',label:'Sous-cutanee (SC)'},
                {value:'topique',label:'Topique (locale)'},{value:'inhalation',label:'Inhalation'},
                {value:'rectale',label:'Rectale'},{value:'oculaire',label:'Oculaire'},
              ]} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4 }}>Quantite en stock</div>
              <InputField type="number" placeholder="0" value={form.quantity} onChange={e => setForm({...form, quantity: parseInt(e.target.value)})} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4 }}>Stock minimum d'alerte</div>
              <InputField type="number" placeholder="10" value={form.min_stock} onChange={e => setForm({...form, min_stock: parseInt(e.target.value)})} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4 }}>Prix unitaire (DA)</div>
              <InputField type="number" placeholder="0" value={form.unit_price} onChange={e => setForm({...form, unit_price: parseFloat(e.target.value)})} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4 }}>Fournisseur</div>
              <InputField placeholder="Nom du fournisseur" value={form.supplier} onChange={e => setForm({...form, supplier: e.target.value})} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4 }}>Numero de lot</div>
              <InputField placeholder="ex: LOT-2024-001" value={form.lot} onChange={e => setForm({...form, lot: e.target.value})} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4 }}>Date de peremption</div>
              <InputField type="date" value={form.expiry_date} onChange={e => setForm({...form, expiry_date: e.target.value})} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={save} style={{ padding: '8px 20px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>Enregistrer</button>
            <button onClick={() => setShowForm(false)} style={{ padding: '8px 20px', background: 'transparent', border: '0.5px solid var(--color-border-secondary)', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>Annuler</button>
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10, marginBottom: 16 }}>
        <div style={{ background: '#FCEBEB', border: '0.5px solid #F7C1C1', borderRadius: 10, padding: '12px 16px', textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 500, color: '#A32D2D' }}>{stock.filter(isExpired).length}</div>
          <div style={{ fontSize: 11, color: '#A32D2D', marginTop: 4 }}>Perimes</div>
        </div>
        <div style={{ background: '#FAEEDA', border: '0.5px solid #FAC775', borderRadius: 10, padding: '12px 16px', textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 500, color: '#854F0B' }}>{stock.filter(isExpiringSoon).length}</div>
          <div style={{ fontSize: 11, color: '#854F0B', marginTop: 4 }}>Expirent bientot</div>
        </div>
        <div style={{ background: '#FAEEDA', border: '0.5px solid #FAC775', borderRadius: 10, padding: '12px 16px', textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 500, color: '#854F0B' }}>{stock.filter(isLow).length}</div>
          <div style={{ fontSize: 11, color: '#854F0B', marginTop: 4 }}>Stock bas</div>
        </div>
        <div style={{ background: 'var(--color-background-primary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, padding: '12px 16px', textAlign: 'center' }}>
          <div style={{ fontSize: 22, fontWeight: 500 }}>{stock.length}</div>
          <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginTop: 4 }}>Total references</div>
        </div>
      </div>

      <div style={{ marginBottom: 12 }}>
        <InputField placeholder="Rechercher un medicament..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      <TableWrap
        headers={['Medicament', 'Forme/Dosage', 'Categorie', 'Voie', 'Stock', 'Peremption', 'Statut', 'Actions']}
        rows={filtered.map(s => [
          <div>
            <div style={{ fontWeight: 500, fontSize: 13 }}>{s.name}</div>
            {s.commercial_name && <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)' }}>{s.commercial_name}</div>}
          </div>,
          <div>
            <div style={{ fontSize: 12 }}>{s.form_type || s.form || '-'}</div>
            {s.dosage && <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)' }}>{s.dosage}</div>}
          </div>,
          s.category || '-',
          s.route || '-',
          <span style={{ fontWeight: 500, color: isLow(s) ? '#A32D2D' : 'var(--color-text-primary)' }}>{s.quantity}</span>,
          s.expiry_date ? new Date(s.expiry_date).toLocaleDateString('fr-FR') : '-',
          isExpired(s) ? <Pill label="Perime" type="danger" /> :
          isExpiringSoon(s) ? <Pill label="Expire bientot" type="warning" /> :
          isLow(s) ? <Pill label="Stock bas" type="warning" /> :
          <Pill label="OK" type="success" />,
          <button onClick={() => del(s.med_id)} style={{ fontSize: 12, color: '#A32D2D', background: 'none', border: 'none', cursor: 'pointer' }}>
            <i className="ti ti-trash" style={{ fontSize: 16 }} />
          </button>
        ])}
      />
    </div>
  );
}

function BillingTab() {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ patient_id: '', items: [{ description: '', quantity: 1, unit_price: 0 }], insurance_type: '', insurance_number: '', discount: 0 });

  useEffect(() => { load(); }, []);
  const load = async () => {
    try { const r = await axios.get(`${API_URL}/api/pro/billing`, getAuthConfig()); setInvoices(r.data.invoices || []); }
    catch (e) {} finally { setLoading(false); }
  };
  const save = async () => {
    try { await axios.post(`${API_URL}/api/pro/billing`, form, getAuthConfig()); setShowForm(false); load(); }
    catch (e) { alert('Erreur'); }
  };
  const addItem = () => setForm({...form, items: [...form.items, { description: '', quantity: 1, unit_price: 0 }]});
  const updateItem = (i, field, value) => { const items = [...form.items]; items[i][field] = value; setForm({...form, items}); };
  const removeItem = (i) => setForm({...form, items: form.items.filter((_, idx) => idx !== i)});
  const total = form.items.reduce((s, item) => s + (item.quantity * item.unit_price), 0) * (1 - (form.discount || 0) / 100);

  if (loading) return <div style={{ textAlign: 'center', padding: 40, color: 'var(--color-text-tertiary)' }}>Chargement...</div>;

  return (
    <div>
      <SectionHeader title="Facturation" action="Nouvelle facture" onClick={() => setShowForm(true)} />
      {showForm && (
        <div style={{ background: 'var(--color-background-primary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, padding: 16, marginBottom: 16 }}>
          <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 14 }}>Nouvelle facture</div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 14 }}>
            <InputField placeholder="ID Patient *" value={form.patient_id} onChange={e => setForm({...form, patient_id: e.target.value})} />
            <SelectField value={form.insurance_type} onChange={e => setForm({...form, insurance_type: e.target.value})} options={[
              {value:'',label:'Sans assurance'},{value:'cnas',label:'CNAS'},{value:'casnos',label:'CASNOS'},{value:'mutuelle',label:'Mutuelle'},
            ]} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
              <span style={{ fontSize: 13, fontWeight: 500 }}>Actes / Prestations</span>
              <button onClick={addItem} style={{ fontSize: 12, color: '#185FA5', background: 'none', border: 'none', cursor: 'pointer' }}>+ Ajouter</button>
            </div>
            {form.items.map((item, i) => (
              <div key={i} style={{ display: 'flex', gap: 8, marginBottom: 6 }}>
                <InputField placeholder="Description" value={item.description} onChange={e => updateItem(i, 'description', e.target.value)} style={{ flex: 2 }} />
                <InputField placeholder="Qté" type="number" value={item.quantity} onChange={e => updateItem(i, 'quantity', parseInt(e.target.value))} style={{ width: 60 }} />
                <InputField placeholder="Prix DA" type="number" value={item.unit_price} onChange={e => updateItem(i, 'unit_price', parseFloat(e.target.value))} style={{ width: 100 }} />
                {i > 0 && <button onClick={() => removeItem(i)} style={{ color: '#A32D2D', background: 'none', border: 'none', cursor: 'pointer', fontSize: 16 }}>×</button>}
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14 }}>
            <div style={{ fontSize: 15, fontWeight: 500 }}>Total : {Math.round(total).toLocaleString('fr-FR')} DA</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13 }}>
              <span>Remise %</span>
              <InputField type="number" value={form.discount} onChange={e => setForm({...form, discount: parseFloat(e.target.value)})} style={{ width: 70 }} />
            </div>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={save} style={{ padding: '7px 18px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>Créer la facture</button>
            <button onClick={() => setShowForm(false)} style={{ padding: '7px 18px', background: 'transparent', border: '0.5px solid var(--color-border-secondary)', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>Annuler</button>
          </div>
        </div>
      )}
      <TableWrap
        headers={['N° Facture', 'Patient', 'Assurance', 'Total', 'Statut', 'Date']}
        rows={invoices.map(inv => [
          <span style={{ fontFamily: 'monospace', fontSize: 12 }}>{inv.invoice_id}</span>,
          inv.patient_id,
          inv.insurance_type ? inv.insurance_type.toUpperCase() : '—',
          <span style={{ fontWeight: 500 }}>{Math.round(inv.total).toLocaleString('fr-FR')} DA</span>,
          <Pill label={inv.status === 'paid' ? 'Payée' : 'En attente'} type={inv.status === 'paid' ? 'success' : 'warning'} />,
          new Date(inv.created_at).toLocaleDateString('fr-FR'),
          <button onClick={() => generateInvoicePDF(null, inv)}
            style={{ padding: '3px 10px', background: '#E6F1FB', color: '#185FA5', border: '0.5px solid #B5D4F4', borderRadius: 6, fontSize: 11, cursor: 'pointer' }}>
            <i className="ti ti-printer" style={{ fontSize: 13 }} /> PDF
          </button>
        ])}
      />
    </div>
  );
}

function AdmissionsTab() {
  const [admissions, setAdmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [patients, setPatients] = useState([]);
  const [patientSearch, setPatientSearch] = useState('');
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [beds, setBeds] = useState([]);
  const [form, setForm] = useState({
    patient_id: '', patient_name: '', service: '', bed_number: '',
    doctor_name: '', reason: '', admitted_at: '', expected_discharge: '',
    insurance_type: '', notes: ''
  });
  const [confirmAction, setConfirmAction] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => { load(); loadBeds(); }, []);

  const load = async () => {
    try { const r = await axios.get(API_URL + '/api/pro/admissions', getAuthConfig()); setAdmissions(r.data.admissions || []); }
    catch(e) {} finally { setLoading(false); }
  };

  const loadBeds = async () => {
    try { const r = await axios.get(API_URL + '/api/pro/beds', getAuthConfig()); setBeds(r.data.beds || []); }
    catch(e) {}
  };

  const searchPatients = async () => {
    if (!patientSearch.trim()) return;
    try {
      const r = await axios.get(API_URL + '/api/clinic/patients?search=' + encodeURIComponent(patientSearch), getAuthConfig());
      setPatients(r.data.patients || []);
    } catch(e) { setPatients([]); }
  };

  const selectPatient = (p) => {
    setSelectedPatient(p);
    setPatients([]);
    setPatientSearch(p.first_name + ' ' + p.last_name);
    setForm({...form, patient_id: p.clinic_patient_id || p.patient_id, patient_name: p.first_name + ' ' + p.last_name, patient_dob: p.date_of_birth || ''});
  };

  const save = async () => {
    if (!form.patient_name || !form.service) { setError('Patient et service obligatoires'); return; }
    setSaving(true); setError('');
    try {
      await axios.post(API_URL + '/api/pro/admissions', form, getAuthConfig());
      setShowForm(false);
      setForm({ patient_id: '', patient_name: '', service: '', bed_number: '', doctor_name: '', reason: '', admitted_at: '', expected_discharge: '', insurance_type: '', notes: '' });
      setSelectedPatient(null);
      setPatientSearch('');
      load();
      loadBeds();
    } catch(e) { setError(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Erreur lors de l'admission"); }
    finally { setSaving(false); }
  };

  const doDischarge = async (adm) => {
    setError('');
    try {
      await axios.put(API_URL + '/api/pro/admissions/' + adm.admission_id, { status: 'discharged', discharged_at: new Date().toISOString() }, getAuthConfig());
      if (adm.bed_number) {
        const bed = beds.find(b => b.room_number === adm.bed_number);
        if (bed) await axios.put(API_URL + '/api/pro/beds/' + bed.bed_id, { status: 'available', patient_id: null }, getAuthConfig());
      }
      setConfirmAction(null); load(); loadBeds();
    } catch(e) { setError('Erreur lors de la sortie'); setConfirmAction(null); }
  };

  const doDelete = async (adm) => {
    setError('');
    try {
      await axios.delete(API_URL + '/api/pro/admissions/' + adm.admission_id, getAuthConfig());
      setConfirmAction(null); load(); loadBeds();
    } catch(e) { setError('Erreur lors de la suppression'); setConfirmAction(null); }
  };

  const calcAge = (dob) => {
    if (!dob) return '-';
    const d = new Date(dob);
    if (isNaN(d.getTime())) return '-';
    const now = new Date();
    let age = now.getFullYear() - d.getFullYear();
    const m = now.getMonth() - d.getMonth();
    if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age--;
    return age >= 0 ? age + ' ans' : '-';
  };

  const SERVICES = ['Cardiologie','Chirurgie generale','Chirurgie cardiaque','Medecine interne','Neurologie','Pediatrie','Gynecologie-Obstetrique','Orthopedique','Pneumologie','Urologie','ORL','Ophtalmologie','Dermatologie','Reanimation','Urgences','Oncologie','Nephrologie','Gastroenterologie','Endocrinologie','Psychiatrie'];

  const availableBeds = beds.filter(b => b.status === 'available');
  const activeAdmissions = admissions.filter(a => a.status === 'active');
  const todayDischarge = admissions.filter(a => a.expected_discharge && a.expected_discharge.startsWith(new Date().toISOString().split('T')[0]) && a.status === 'active');

  const inputStyle = { width: '100%', padding: '8px 12px', border: '0.5px solid #CBD5E1', borderRadius: 8, fontSize: 13, color: 'var(--color-text-primary)', background: 'var(--color-background-primary)', outline: 'none' };
  const labelStyle = { fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4, display: 'block' };

  if (loading) return <div style={{ textAlign: 'center', padding: 40, color: 'var(--color-text-tertiary)' }}>Chargement...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div style={{ fontSize: 14, fontWeight: 500 }}>Admissions et sejours</div>
        <button onClick={() => setShowForm(!showForm)}
          style={{ padding: '7px 16px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6 }}>
          <i className="ti ti-plus" style={{ fontSize: 14 }} aria-hidden="true" /> Nouvelle admission
        </button>
      </div>

      {error && (
        <div style={{ background: '#FCEBEB', border: '0.5px solid #F7C1C1', color: '#A32D2D', borderRadius: 8, padding: '10px 14px', marginBottom: 12, fontSize: 13 }}>{error}</div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 10, marginBottom: 16 }}>
        <div style={{ background: '#E6F1FB', border: '0.5px solid #B5D4F4', borderRadius: 10, padding: '14px 16px' }}>
          <div style={{ fontSize: 11, color: '#185FA5', marginBottom: 6 }}>Patients hospitalises</div>
          <div style={{ fontSize: 28, fontWeight: 500, color: '#185FA5' }}>{activeAdmissions.length}</div>
          <div style={{ fontSize: 11, color: '#185FA5', marginTop: 4 }}>Actifs ce jour</div>
        </div>
        <div style={{ background: '#FAEEDA', border: '0.5px solid #FAC775', borderRadius: 10, padding: '14px 16px' }}>
          <div style={{ fontSize: 11, color: '#854F0B', marginBottom: 6 }}>Sorties prevues aujourd'hui</div>
          <div style={{ fontSize: 28, fontWeight: 500, color: '#854F0B' }}>{todayDischarge.length}</div>
          <div style={{ fontSize: 11, color: '#854F0B', marginTop: 4 }}>A organiser</div>
        </div>
        <div style={{ background: '#EAF3DE', border: '0.5px solid #C0DD97', borderRadius: 10, padding: '14px 16px' }}>
          <div style={{ fontSize: 11, color: '#3B6D11', marginBottom: 6 }}>Lits disponibles</div>
          <div style={{ fontSize: 28, fontWeight: 500, color: '#3B6D11' }}>{availableBeds.length}</div>
          <div style={{ fontSize: 11, color: '#3B6D11', marginTop: 4 }}>Sur {beds.length} total</div>
        </div>
        <div style={{ background: 'var(--color-background-primary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, padding: '14px 16px' }}>
          <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 6 }}>Total admissions</div>
          <div style={{ fontSize: 28, fontWeight: 500, color: 'var(--color-text-primary)' }}>{admissions.length}</div>
          <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', marginTop: 4 }}>Depuis le debut</div>
        </div>
      </div>

      {showForm && (
        <div style={{ background: '#ffffff', border: '1.5px solid #B5D4F4', borderRadius: 10, padding: 20, marginBottom: 16 }}>
          <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 16, paddingBottom: 12, borderBottom: '0.5px solid var(--color-border-tertiary)' }}>
            Nouvelle admission
          </div>

          <div style={{ marginBottom: 14 }}>
            <label style={labelStyle}>Rechercher le patient *</label>
            <div style={{ display: 'flex', gap: 10, marginBottom: 8 }}>
              <input style={{ ...inputStyle, flex: 1 }} placeholder="Nom, prenom ou telephone..."
                value={patientSearch} onChange={e => setPatientSearch(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && searchPatients()} />
              <button onClick={searchPatients} style={{ padding: '8px 16px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
                Rechercher
              </button>
            </div>
            {patients.length > 0 && (
              <div style={{ border: '0.5px solid var(--color-border-tertiary)', borderRadius: 8, overflow: 'hidden', marginBottom: 8 }}>
                {patients.map((p, i) => (
                  <div key={i} onClick={() => selectPatient(p)}
                    style={{ padding: '10px 14px', cursor: 'pointer', borderBottom: i < patients.length-1 ? '0.5px solid var(--color-border-tertiary)' : 'none', display: 'flex', justifyContent: 'space-between' }}
                    onMouseEnter={e => e.currentTarget.style.background='var(--color-background-secondary)'}
                    onMouseLeave={e => e.currentTarget.style.background='transparent'}>
                    <span style={{ fontWeight: 500, fontSize: 13 }}>{p.first_name} {p.last_name}</span>
                    <span style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>{p.phone || ''}</span>
                  </div>
                ))}
              </div>
            )}
            {selectedPatient && (
              <div style={{ background: '#E6F1FB', border: '0.5px solid #B5D4F4', borderRadius: 8, padding: '8px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: 13, fontWeight: 500, color: '#0C447C' }}>{selectedPatient.first_name} {selectedPatient.last_name}</span>
                <button onClick={() => { setSelectedPatient(null); setPatientSearch(''); setForm({...form, patient_id: '', patient_name: ''}); }}
                  style={{ background: 'none', border: 'none', color: '#185FA5', cursor: 'pointer', fontSize: 16 }}>x</button>
              </div>
            )}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '10px 16px', marginBottom: 14 }}>
            <div>
              <label style={labelStyle}>Service *</label>
              <select style={inputStyle} value={form.service} onChange={e => setForm({...form, service: e.target.value})}>
                <option value="">Selectionner...</option>
                {SERVICES.map(s => <option key={s} value={s}>{s}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Lit assigne</label>
              <select style={inputStyle} value={form.bed_number} onChange={e => setForm({...form, bed_number: e.target.value})}>
                <option value="">Selectionner un lit...</option>
                {availableBeds.map(b => <option key={b.bed_id} value={b.room_number}>Lit {b.room_number} — {b.room_type} {b.service ? '(' + b.service + ')' : ''}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Medecin referent</label>
              <input style={inputStyle} placeholder="Dr. Nom" value={form.doctor_name} onChange={e => setForm({...form, doctor_name: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>Date d'admission</label>
              <input style={inputStyle} type="datetime-local" value={form.admitted_at} onChange={e => setForm({...form, admitted_at: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>Sortie prevue</label>
              <input style={inputStyle} type="date" value={form.expected_discharge} onChange={e => setForm({...form, expected_discharge: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>Assurance</label>
              <select style={inputStyle} value={form.insurance_type} onChange={e => setForm({...form, insurance_type: e.target.value})}>
                <option value="">Sans assurance</option>
                <option value="cnas">CNAS</option>
                <option value="casnos">CASNOS</option>
                <option value="mutuelle">Mutuelle</option>
              </select>
            </div>
            <div style={{ gridColumn: 'span 3' }}>
              <label style={labelStyle}>Motif d'hospitalisation</label>
              <textarea style={{ ...inputStyle, resize: 'vertical', minHeight: 60 }} placeholder="Motif d'admission, diagnostic principal..." value={form.reason} onChange={e => setForm({...form, reason: e.target.value})} />
            </div>
          </div>

          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={save} disabled={saving}
              style={{ padding: '8px 20px', background: '#185FA5', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500, opacity: saving ? 0.7 : 1 }}>
              {saving ? 'Enregistrement...' : 'Admettre le patient'}
            </button>
            <button onClick={() => setShowForm(false)}
              style={{ padding: '8px 20px', background: 'transparent', border: '0.5px solid var(--color-border-secondary)', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
              Annuler
            </button>
          </div>
        </div>
      )}

      {activeAdmissions.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, color: 'var(--color-text-tertiary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10 }}>
          <i className="ti ti-bed" style={{ fontSize: 32, display: 'block', marginBottom: 8 }} aria-hidden="true" />
          Aucun patient hospitalise actuellement
        </div>
      ) : (
        <div style={{ border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, overflow: 'hidden' }}>
          <div style={{ padding: '8px 14px', background: 'var(--color-background-secondary)', borderBottom: '0.5px solid var(--color-border-tertiary)', display: 'grid', gridTemplateColumns: '1fr 80px 120px 80px 120px 110px 100px 120px', gap: 0 }}>
            {['Patient', 'Age', 'Service', 'Lit', 'Medecin', 'Admission', 'Sortie prevue', 'Actions'].map(h => (
              <div key={h} style={{ fontSize: 11, color: 'var(--color-text-secondary)', fontWeight: 500 }}>{h}</div>
            ))}
          </div>
          {activeAdmissions.map((a, i) => {
            const isToday = a.expected_discharge && a.expected_discharge.startsWith(new Date().toISOString().split('T')[0]);
            const isOverdue = a.expected_discharge && new Date(a.expected_discharge) < new Date();
            return (
              <div key={a.admission_id} style={{ padding: '12px 14px', borderBottom: i < activeAdmissions.length-1 ? '0.5px solid var(--color-border-tertiary)' : 'none', display: 'grid', gridTemplateColumns: '1fr 80px 120px 80px 120px 110px 100px 120px', gap: 0, alignItems: 'center', background: isOverdue ? '#FFF5F5' : 'transparent' }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 500 }}>{a.patient_name}</div>
                  {a.reason && <div style={{ fontSize: 11, color: 'var(--color-text-tertiary)', marginTop: 2 }}>{a.reason.substring(0, 40)}{a.reason.length > 40 ? '...' : ''}</div>}
                </div>
                <div style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>{calcAge(a.patient_dob)}</div>
                <div style={{ fontSize: 12 }}>{a.service || '-'}</div>
                <div style={{ fontSize: 12 }}>{a.bed_number ? 'Lit ' + a.bed_number : '-'}</div>
                <div style={{ fontSize: 12 }}>{a.doctor_name || '-'}</div>
                <div style={{ fontSize: 12 }}>{a.admitted_at ? new Date(a.admitted_at).toLocaleDateString('fr-FR') : '-'}</div>
                <div style={{ fontSize: 12, fontWeight: isToday || isOverdue ? 500 : 400, color: isOverdue ? '#A32D2D' : isToday ? '#854F0B' : 'var(--color-text-primary)' }}>
                  {a.expected_discharge ? new Date(a.expected_discharge).toLocaleDateString('fr-FR') : '-'}
                  {isToday && !isOverdue && <div style={{ fontSize: 10, color: '#854F0B' }}>Aujourd'hui</div>}
                  {isOverdue && <div style={{ fontSize: 10, color: '#A32D2D' }}>En retard</div>}
                </div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <button onClick={() => setConfirmAction({ type: 'discharge', adm: a })}
                    style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '0.5px solid #C0DD97', cursor: 'pointer', background: '#EAF3DE', color: '#3B6D11' }}>
                    Sortie
                  </button>
                  <button onClick={() => setConfirmAction({ type: 'delete', adm: a })} title="Supprimer"
                    style={{ fontSize: 11, background: 'none', border: 'none', cursor: 'pointer', color: '#A32D2D', padding: 0 }}>
                    <i className="ti ti-trash" style={{ fontSize: 15 }} />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {confirmAction && (
        <div onClick={() => setConfirmAction(null)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div onClick={e => e.stopPropagation()} style={{ background: '#ffffff', borderRadius: 12, width: '90%', maxWidth: 400, padding: 24, boxShadow: '0 8px 30px rgba(0,0,0,0.18)' }}>
            <div style={{ fontSize: 16, fontWeight: 600, color: 'var(--color-text-primary)', marginBottom: 8 }}>
              {confirmAction.type === 'discharge' ? 'Confirmer la sortie ?' : 'Supprimer cette admission ?'}
            </div>
            <div style={{ fontSize: 13, color: 'var(--color-text-secondary)', marginBottom: 20, lineHeight: 1.5 }}>
              <b>{confirmAction.adm.patient_name}</b>{confirmAction.adm.service ? ' — ' + confirmAction.adm.service : ''}.{' '}
              {confirmAction.type === 'discharge' ? 'Le lit sera libere.' : 'Cette action est irreversible.'}
            </div>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
              <button onClick={() => setConfirmAction(null)} style={{ fontSize: 13, padding: '8px 16px', borderRadius: 8, border: '0.5px solid var(--color-border-tertiary)', background: '#fff', color: 'var(--color-text-secondary)', cursor: 'pointer' }}>Annuler</button>
              {confirmAction.type === 'discharge' ? (
                <button onClick={() => doDischarge(confirmAction.adm)} style={{ fontSize: 13, padding: '8px 16px', borderRadius: 8, border: 'none', background: '#3B6D11', color: '#fff', cursor: 'pointer' }}>Confirmer la sortie</button>
              ) : (
                <button onClick={() => doDelete(confirmAction.adm)} style={{ fontSize: 13, padding: '8px 16px', borderRadius: 8, border: 'none', background: '#A32D2D', color: '#fff', cursor: 'pointer' }}>Supprimer</button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function UrgencesTab() {
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    patient_name: '', age: '', gender: 'M', triage_level: 3,
    reason: '', blood_pressure: '', pulse: '', temperature: '',
    spo2: '', glasgow: '', pain_score: '', blood_glucose: '',
    doctor: '', notes: ''
  });

  useEffect(() => { load(); const interval = setInterval(load, 30000); return () => clearInterval(interval); }, []);

  const load = async () => {
    try { const r = await axios.get(API_URL + '/api/pro/urgences', getAuthConfig()); setPatients(r.data.patients || []); }
    catch(e) {} finally { setLoading(false); }
  };

  const save = async () => {
    if (!form.patient_name || !form.reason) { alert('Nom et motif obligatoires'); return; }
    setSaving(true);
    try {
      await axios.post(API_URL + '/api/pro/urgences', form, getAuthConfig());
      setShowForm(false);
      setForm({ patient_name: '', age: '', gender: 'M', triage_level: 3, reason: '', blood_pressure: '', pulse: '', temperature: '', spo2: '', glasgow: '', pain_score: '', blood_glucose: '', doctor: '', notes: '' });
      load();
    } catch(e) { alert('Erreur'); }
    finally { setSaving(false); }
  };

  const updateStatus = async (id, status) => {
    try { await axios.put(API_URL + '/api/pro/urgences/' + id, { status }, getAuthConfig()); load(); }
    catch(e) { alert('Erreur'); }
  };

  const updateTriage = async (id, level) => {
    try { await axios.put(API_URL + '/api/pro/urgences/' + id, { triage_level: parseInt(level) }, getAuthConfig()); load(); }
    catch(e) { alert('Erreur'); }
  };

  const getWaitTime = (arrived_at) => {
    const diff = (new Date() - new Date(arrived_at)) / 60000;
    if (diff < 60) return Math.round(diff) + ' min';
    return Math.floor(diff/60) + 'h ' + Math.round(diff%60) + 'min';
  };

  const TRIAGE = {
    1: { label: 'P1 — Immediat', bg: '#FCEBEB', border: '#F7C1C1', text: '#A32D2D', badgeBg: '#A32D2D' },
    2: { label: 'P2 — Tres urgent', bg: '#FAEEDA', border: '#FAC775', text: '#854F0B', badgeBg: '#854F0B' },
    3: { label: 'P3 — Urgent', bg: '#E6F1FB', border: '#B5D4F4', text: '#185FA5', badgeBg: '#185FA5' },
    4: { label: 'P4 — Peu urgent', bg: '#EAF3DE', border: '#C0DD97', text: '#3B6D11', badgeBg: '#3B6D11' },
    5: { label: 'P5 — Non urgent', bg: 'var(--color-background-secondary)', border: 'var(--color-border-tertiary)', text: 'var(--color-text-secondary)', badgeBg: 'var(--color-text-secondary)' },
  };

  const counts = [1,2,3,4,5].map(l => ({ level: l, count: patients.filter(p => p.triage_level === l).length }));

  const isAlert = (type, value) => {
    if (!value) return false;
    const v = parseFloat(value);
    if (type === 'spo2') return v < 95;
    if (type === 'pulse') return v < 50 || v > 110;
    if (type === 'temp') return v > 38.5 || v < 35;
    if (type === 'glucose') return v < 0.5 || v > 2;
    return false;
  };

  const inputStyle = { width: '100%', padding: '8px 12px', border: '0.5px solid #CBD5E1', borderRadius: 8, fontSize: 13, color: 'var(--color-text-primary)', background: 'var(--color-background-primary)', outline: 'none' };
  const labelStyle = { fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4, display: 'block' };

  if (loading) return <div style={{ textAlign: 'center', padding: 40, color: 'var(--color-text-tertiary)' }}>Chargement...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 500 }}>Service des urgences</div>
          <div style={{ fontSize: 12, color: 'var(--color-text-secondary)', marginTop: 2 }}>
            {patients.length} patient{patients.length > 1 ? 's' : ''} en attente — Actualisation automatique toutes les 30s
          </div>
        </div>
        <button onClick={() => setShowForm(!showForm)}
          style={{ padding: '7px 16px', background: '#A32D2D', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500, display: 'flex', alignItems: 'center', gap: 6 }}>
          <i className="ti ti-plus" style={{ fontSize: 14 }} aria-hidden="true" /> Nouveau patient
        </button>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: 10, marginBottom: 16 }}>
        {counts.map(({ level, count }) => {
          const t = TRIAGE[level];
          return (
            <div key={level} style={{ background: t.bg, border: '0.5px solid ' + t.border, borderRadius: 10, padding: '12px', textAlign: 'center' }}>
              <div style={{ fontSize: 24, fontWeight: 500, color: t.text }}>{count}</div>
              <div style={{ fontSize: 11, color: t.text, marginTop: 3 }}>{t.label}</div>
            </div>
          );
        })}
      </div>

      {showForm && (
        <div style={{ background: 'var(--color-background-primary)', border: '1.5px solid #F7C1C1', borderRadius: 10, padding: 20, marginBottom: 16 }}>
          <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 16, paddingBottom: 12, borderBottom: '0.5px solid var(--color-border-tertiary)', color: '#A32D2D' }}>
            Nouveau patient aux urgences
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: '10px 16px', marginBottom: 12 }}>
            <div>
              <label style={labelStyle}>Nom complet *</label>
              <input style={inputStyle} placeholder="Nom et prenom" value={form.patient_name} onChange={e => setForm({...form, patient_name: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>Age</label>
              <input style={inputStyle} type="number" placeholder="Age" value={form.age} onChange={e => setForm({...form, age: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>Sexe</label>
              <select style={inputStyle} value={form.gender} onChange={e => setForm({...form, gender: e.target.value})}>
                <option value="M">Masculin</option>
                <option value="F">Feminin</option>
              </select>
            </div>
          </div>

          <div style={{ marginBottom: 12 }}>
            <label style={labelStyle}>Niveau de triage *</label>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5,1fr)', gap: 8 }}>
              {[1,2,3,4,5].map(l => {
                const t = TRIAGE[l];
                return (
                  <button key={l} onClick={() => setForm({...form, triage_level: l})}
                    style={{ padding: '10px 6px', border: form.triage_level === l ? '2px solid ' + t.text : '0.5px solid ' + t.border, borderRadius: 8, fontSize: 12, cursor: 'pointer', background: t.bg, color: t.text, fontWeight: form.triage_level === l ? 700 : 400 }}>
                    {t.label}
                  </button>
                );
              })}
            </div>
          </div>

          <div style={{ marginBottom: 12 }}>
            <label style={labelStyle}>Motif de consultation *</label>
            <textarea style={{ ...inputStyle, resize: 'vertical', minHeight: 60 }} placeholder="Decrivez le motif de consultation..." value={form.reason} onChange={e => setForm({...form, reason: e.target.value})} />
          </div>

          <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--color-text-secondary)', marginBottom: 10, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Constantes initiales</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '10px 16px', marginBottom: 16 }}>
            <div>
              <label style={labelStyle}>Tension arterielle</label>
              <input style={inputStyle} placeholder="ex: 120/80" value={form.blood_pressure} onChange={e => setForm({...form, blood_pressure: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>Pouls (bpm)</label>
              <input style={inputStyle} type="number" placeholder="ex: 72" value={form.pulse} onChange={e => setForm({...form, pulse: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>Temperature (°C)</label>
              <input style={inputStyle} type="number" step="0.1" placeholder="ex: 37.2" value={form.temperature} onChange={e => setForm({...form, temperature: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>SpO2 (%)</label>
              <input style={inputStyle} type="number" placeholder="ex: 98" value={form.spo2} onChange={e => setForm({...form, spo2: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>Glasgow (/15)</label>
              <input style={inputStyle} type="number" min="3" max="15" placeholder="ex: 15" value={form.glasgow} onChange={e => setForm({...form, glasgow: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>Douleur EVA (/10)</label>
              <input style={inputStyle} type="number" min="0" max="10" placeholder="ex: 5" value={form.pain_score} onChange={e => setForm({...form, pain_score: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>Glycemie (g/L)</label>
              <input style={inputStyle} type="number" step="0.01" placeholder="ex: 0.95" value={form.blood_glucose} onChange={e => setForm({...form, blood_glucose: e.target.value})} />
            </div>
            <div>
              <label style={labelStyle}>Medecin responsable</label>
              <input style={inputStyle} placeholder="Dr. Nom" value={form.doctor} onChange={e => setForm({...form, doctor: e.target.value})} />
            </div>
          </div>

          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={save} disabled={saving}
              style={{ padding: '8px 20px', background: '#A32D2D', color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', fontWeight: 500, opacity: saving ? 0.7 : 1 }}>
              {saving ? 'Enregistrement...' : 'Admettre le patient'}
            </button>
            <button onClick={() => setShowForm(false)}
              style={{ padding: '8px 20px', background: 'transparent', border: '0.5px solid var(--color-border-secondary)', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>
              Annuler
            </button>
          </div>
        </div>
      )}

      {patients.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, color: 'var(--color-text-tertiary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10 }}>
          <i className="ti ti-heart-plus" style={{ fontSize: 32, display: 'block', marginBottom: 8 }} aria-hidden="true" />
          Aucun patient aux urgences en ce moment
        </div>
      ) : (
        <div style={{ border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, overflow: 'hidden' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '40px 160px 60px 1fr 140px 80px 150px', gap: 0, padding: '8px 14px', background: 'var(--color-background-secondary)', borderBottom: '0.5px solid var(--color-border-tertiary)' }}>
            {['P', 'Patient', 'Age', 'Motif', 'Constantes', 'Attente', 'Actions'].map(h => (
              <div key={h} style={{ fontSize: 11, color: 'var(--color-text-secondary)', fontWeight: 500 }}>{h}</div>
            ))}
          </div>
          {patients.sort((a,b) => a.triage_level - b.triage_level).map((p, i) => {
            const t = TRIAGE[p.triage_level] || TRIAGE[5];
            return (
              <div key={p.urgence_id} style={{ display: 'grid', gridTemplateColumns: '40px 160px 60px 1fr 140px 80px 150px', gap: 0, padding: '12px 14px', borderBottom: i < patients.length-1 ? '0.5px solid var(--color-border-tertiary)' : 'none', alignItems: 'center', background: p.triage_level === 1 ? '#FFF5F5' : 'transparent' }}>
                <div style={{ width: 28, height: 28, borderRadius: '50%', background: t.badgeBg, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 11, fontWeight: 700 }}>
                  P{p.triage_level}
                </div>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 500 }}>{p.patient_name}</div>
                  <div style={{ fontSize: 11, color: 'var(--color-text-secondary)' }}>{p.gender}</div>
                </div>
                <div style={{ fontSize: 12, color: 'var(--color-text-secondary)' }}>{p.age ? p.age + ' ans' : '-'}</div>
                <div style={{ fontSize: 12, paddingRight: 8 }}>{p.reason}</div>
                <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                  {p.blood_pressure && <span style={{ fontSize: 10, padding: '1px 5px', borderRadius: 4, background: 'var(--color-background-secondary)', color: 'var(--color-text-secondary)' }}>TA: {p.blood_pressure}</span>}
                  {p.spo2 && <span style={{ fontSize: 10, padding: '1px 5px', borderRadius: 4, background: isAlert('spo2', p.spo2) ? '#FCEBEB' : 'var(--color-background-secondary)', color: isAlert('spo2', p.spo2) ? '#A32D2D' : 'var(--color-text-secondary)' }}>SpO2: {p.spo2}%</span>}
                  {p.temperature && <span style={{ fontSize: 10, padding: '1px 5px', borderRadius: 4, background: isAlert('temp', p.temperature) ? '#FCEBEB' : 'var(--color-background-secondary)', color: isAlert('temp', p.temperature) ? '#A32D2D' : 'var(--color-text-secondary)' }}>T: {p.temperature}°C</span>}
                  {p.pulse && <span style={{ fontSize: 10, padding: '1px 5px', borderRadius: 4, background: isAlert('pulse', p.pulse) ? '#FCEBEB' : 'var(--color-background-secondary)', color: isAlert('pulse', p.pulse) ? '#A32D2D' : 'var(--color-text-secondary)' }}>FC: {p.pulse}</span>}
                  {p.glasgow && <span style={{ fontSize: 10, padding: '1px 5px', borderRadius: 4, background: parseInt(p.glasgow) < 13 ? '#FCEBEB' : 'var(--color-background-secondary)', color: parseInt(p.glasgow) < 13 ? '#A32D2D' : 'var(--color-text-secondary)' }}>GCS: {p.glasgow}</span>}
                </div>
                <div style={{ fontSize: 12, fontWeight: 500, color: t.text }}>{getWaitTime(p.arrived_at)}</div>
                <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                  <select value={p.triage_level} onChange={e => updateTriage(p.urgence_id, e.target.value)}
                    style={{ fontSize: 11, padding: '3px 6px', borderRadius: 6, border: '0.5px solid ' + t.border, background: t.bg, color: t.text, cursor: 'pointer' }}>
                    {[1,2,3,4,5].map(l => <option key={l} value={l}>P{l}</option>)}
                  </select>
                  <button onClick={() => updateStatus(p.urgence_id, p.status === 'waiting' ? 'in_progress' : 'discharged')}
                    style={{ fontSize: 11, padding: '3px 8px', borderRadius: 6, border: '0.5px solid var(--color-border-tertiary)', cursor: 'pointer', background: p.status === 'waiting' ? '#E6F1FB' : '#EAF3DE', color: p.status === 'waiting' ? '#185FA5' : '#3B6D11' }}>
                    {p.status === 'waiting' ? 'Prendre en charge' : 'Sortie'}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

function StatsTab() {
  return (
    <div>
      <SectionHeader title="Statistiques & rapports" />
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12 }}>
        <StatCard label="Taux d'occupation" value="75%" sub="Moyenne du mois" />
        <StatCard label="Durée moy. séjour" value="4.2j" sub="Par patient" />
        <StatCard label="Interventions / mois" value="28" sub="Bloc opératoire" />
        <StatCard label="Analyses / mois" value="142" sub="Laboratoire" />
        <StatCard label="Examens imagerie" value="67" sub="Ce mois" />
        <StatCard label="Factures émises" value="89" sub="Dont 72 payées" />
      </div>
      <div style={{ marginTop: 20, padding: 24, background: 'var(--color-background-primary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, textAlign: 'center', color: 'var(--color-text-tertiary)' }}>
        <i className="ti ti-chart-bar" style={{ fontSize: 32, display: 'block', marginBottom: 8 }} />
        Graphiques détaillés — disponibles prochainement
      </div>
    </div>
  );
}

function StaffTab() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', role: 'infirmier', phone: '', email: '' });

  useEffect(() => { load(); }, []);
  const load = async () => {
    try { const r = await axios.get(`${API_URL}/api/pro/staff`, getAuthConfig()); setStaff(r.data.staff || []); }
    catch (e) {} finally { setLoading(false); }
  };
  const save = async () => {
    try { await axios.post(`${API_URL}/api/pro/staff`, form, getAuthConfig()); setShowForm(false); setForm({ name: '', role: 'infirmier', phone: '', email: '' }); load(); }
    catch (e) { alert('Erreur'); }
  };
  const del = async (id) => {
    if (!window.confirm('Supprimer ?')) return;
    try { await axios.delete(`${API_URL}/api/pro/staff/${id}`, getAuthConfig()); load(); }
    catch (e) { alert('Erreur'); }
  };

  const roleLabels = { medecin: 'Médecin', infirmier: 'Infirmier(ère)', aide_soignant: 'Aide-soignant(e)', secretaire: 'Secrétaire', technicien: 'Technicien', autre: 'Autre' };
  const roleType = { medecin: 'info', infirmier: 'success', aide_soignant: 'warning', secretaire: 'neutral', technicien: 'neutral', autre: 'neutral' };

  if (loading) return <div style={{ textAlign: 'center', padding: 40, color: 'var(--color-text-tertiary)' }}>Chargement...</div>;

  return (
    <div>
      <SectionHeader title="Ressources humaines" action="Ajouter du personnel" onClick={() => setShowForm(true)} />
      {showForm && (
        <FormCard title="Nouveau membre du personnel" onSave={save} onCancel={() => setShowForm(false)}>
          <InputField placeholder="Nom complet *" value={form.name} onChange={e => setForm({...form, name: e.target.value})} />
          <SelectField value={form.role} onChange={e => setForm({...form, role: e.target.value})} options={[
            {value:'medecin',label:'Médecin'},{value:'infirmier',label:'Infirmier(ère)'},{value:'aide_soignant',label:'Aide-soignant(e)'},
            {value:'secretaire',label:'Secrétaire'},{value:'technicien',label:'Technicien'},{value:'autre',label:'Autre'},
          ]} />
          <InputField placeholder="Téléphone" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} />
          <InputField placeholder="Email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} />
        </FormCard>
      )}
      <TableWrap
        headers={['Nom', 'Rôle', 'Téléphone', 'Email', 'Actions']}
        rows={staff.map(m => [
          <span style={{ fontWeight: 500 }}>{m.name}</span>,
          <Pill label={roleLabels[m.role] || m.role} type={roleType[m.role] || 'neutral'} />,
          m.phone || '—',
          m.email || '—',
          <button onClick={() => del(m.staff_id)} style={{ fontSize: 12, color: '#A32D2D', background: 'none', border: 'none', cursor: 'pointer' }}><i className="ti ti-trash" style={{ fontSize: 16 }} /></button>
        ])}
      />
    </div>
  );
}

function SettingsTab({ clinic }) {
  return (
    <div>
      <SectionHeader title="Paramètres" />
      <div style={{ background: 'var(--color-background-primary)', border: '0.5px solid var(--color-border-tertiary)', borderRadius: 10, padding: 20 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          {[
            { label: 'Nom de la clinique', value: clinic?.name },
            { label: 'Type', value: clinic?.clinic_type },
            { label: 'Téléphone', value: clinic?.phone },
            { label: 'Email', value: clinic?.email },
            { label: 'Adresse', value: clinic?.address },
            { label: 'Wilaya', value: clinic?.wilaya_code },
          ].map((f, i) => (
            <div key={i}>
              <div style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginBottom: 4 }}>{f.label}</div>
              <div style={{ fontSize: 14, color: 'var(--color-text-primary)', fontWeight: 500 }}>{f.value || '—'}</div>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 20, paddingTop: 16, borderTop: '0.5px solid var(--color-border-tertiary)', fontSize: 13, color: 'var(--color-text-secondary)' }}>
          Pour modifier les informations, utilisez l'onglet Paramètres du dashboard standard.
        </div>
      </div>
    </div>
  );
}
